webpackJsonp([0],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1);
	module.exports = __webpack_require__(326);


/***/ }),
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _defineProperty2 = __webpack_require__(327);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	__webpack_require__(346);
	
	__webpack_require__(350);
	
	__webpack_require__(358);
	
	__webpack_require__(363);
	
	__webpack_require__(364);
	
	__webpack_require__(366);
	
	var _angular = __webpack_require__(368);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(370);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _angularLoadingBar = __webpack_require__(456);
	
	var _angularLoadingBar2 = _interopRequireDefault(_angularLoadingBar);
	
	var _dropdown = __webpack_require__(458);
	
	var _dropdown2 = _interopRequireDefault(_dropdown);
	
	var _carousel = __webpack_require__(467);
	
	var _carousel2 = _interopRequireDefault(_carousel);
	
	var _modal = __webpack_require__(474);
	
	var _modal2 = _interopRequireDefault(_modal);
	
	var _angularTranslate = __webpack_require__(480);
	
	var _angularTranslate2 = _interopRequireDefault(_angularTranslate);
	
	var _angularAnimate = __webpack_require__(481);
	
	var _angularAnimate2 = _interopRequireDefault(_angularAnimate);
	
	var _angularStorage = __webpack_require__(483);
	
	var _angularStorage2 = _interopRequireDefault(_angularStorage);
	
	var _ngFileUpload = __webpack_require__(485);
	
	var _ngFileUpload2 = _interopRequireDefault(_ngFileUpload);
	
	__webpack_require__(487);
	
	__webpack_require__(488);
	
	var _app = __webpack_require__(489);
	
	var _app2 = _interopRequireDefault(_app);
	
	var _common = __webpack_require__(493);
	
	var _common2 = _interopRequireDefault(_common);
	
	var _components = __webpack_require__(556);
	
	var _components2 = _interopRequireDefault(_components);
	
	var _image = __webpack_require__(629);
	
	var _image2 = _interopRequireDefault(_image);
	
	var _account = __webpack_require__(631);
	
	var _account2 = _interopRequireDefault(_account);
	
	var _report = __webpack_require__(633);
	
	var _report2 = _interopRequireDefault(_report);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_angular2.default.module('app', [_angularUiRouter2.default, _angularLoadingBar2.default, _dropdown2.default, _angularTranslate2.default, _angularStorage2.default, _angularAnimate2.default, _carousel2.default, _modal2.default, _ngFileUpload2.default, 'angular-growl', 'summernote', // vedi index.html per le dipendenze di summernote.js
	_common2.default, _components2.default, _image2.default, _account2.default, _report2.default]).config(["$locationProvider", "$urlRouterProvider", function ($locationProvider, $urlRouterProvider) {
	  'ngInject';
	  // @see: https://github.com/angular-ui/ui-router/wiki/Frequently-Asked-Questions
	  // #how-to-configure-your-server-to-work-with-html5mode
	  // $locationProvider.html5Mode(true).hashPrefix('!');
	
	  $urlRouterProvider.otherwise('/');
	}]).config(["$translateProvider", function ($translateProvider) {
	  'ngInject';
	
	  $translateProvider.translations('it', (0, _defineProperty3.default)({
	    'CULTURE': "Cultura",
	    'INFORMATION': "Informazioni",
	    'ITINERARY': "Itinerari",
	    'NATURE': 'Natura',
	    'TYPICALPRODUCT': 'Prodotti tipici',
	    'SERVICE': 'Servizi e ricettività',
	    'OUTDOOR': 'Outdoor'
	  }, 'ITINERARY', 'Itinerari'));
	
	  $translateProvider.preferredLanguage('it');
	}]).config(["growlProvider", function (growlProvider) {
	  'ngInject';
	
	  growlProvider.globalTimeToLive(5000);
	  growlProvider.globalDisableCountDown(true);
	  growlProvider.globalPosition('top-center');
	}]).config(["cfpLoadingBarProvider", function (cfpLoadingBarProvider) {
	  'ngInject';
	
	  cfpLoadingBarProvider.spinnerTemplate = '<div class="sk-cube-grid">' + '  <div class="sk-cube sk-cube1"></div>' + '  <div class="sk-cube sk-cube2"></div>' + '  <div class="sk-cube sk-cube3"></div>' + '  <div class="sk-cube sk-cube4"></div>' + '  <div class="sk-cube sk-cube5"></div>' + '  <div class="sk-cube sk-cube6"></div>' + '  <div class="sk-cube sk-cube7"></div>' + '  <div class="sk-cube sk-cube8"></div>' + '  <div class="sk-cube sk-cube9"></div>' + '</div>';
	
	  // '<div class="loading">' +
	  // '  <span>Caricamento...</span>' +
	  // '</div>'
	}]).config(["$qProvider", function ($qProvider) {
	  'ngInject';
	
	  $qProvider.errorOnUnhandledRejections(false);
	}]).config(["$httpProvider", function ($httpProvider) {
	  'ngInject';
	
	  $httpProvider.interceptors.push('Auth');
	}])
	/* .constant('SERVER_URL', 'http://localhost:8080/api') */
	.constant('SERVER_URL', 'https://www.api.parco.nino.cloud/api').run(["$http", "store", "$state", "$location", function ($http, store, $state, $location) {
	  'ngInject';
	
	  if (store.get("token") && $location.path().indexOf("confirmRegistration") == -1) {
	    $http.defaults.headers.common.Authorization = store.get("token");
	
	    // Reindirizza alla dashboard solo se c'è un token valido
	    // e l'utente è sulla pagina di login.
	    if ($location.path() === '' || $location.path() === '/' || $location.path().indexOf("login") > -1) {
	      $state.go("dashboard.list", { modelEnum: 'CULTURE' });
	    }
	  }
	}]).component('app', _app2.default);
	// import 'bootstrap-css-only/css/bootstrap.css'; //bootstrap 4 va in conflitto con now ui kit

/***/ }),
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _app = __webpack_require__(490);
	
	var _app2 = _interopRequireDefault(_app);
	
	__webpack_require__(491);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var appComponent = {
	  template: _app2.default
	};
	
	exports.default = appComponent;

/***/ }),
/* 490 */
/***/ (function(module, exports) {

	module.exports = "<!-- Place all UI elements intended to be present across all routes in this file -->\r\n<div class=\"app\">\r\n  <div ui-view></div>\r\n</div>\r\n"

/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(492);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(349)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../node_modules/css-loader/index.js!../../node_modules/sass-loader/index.js!./app.scss", function() {
				var newContent = require("!!../../node_modules/css-loader/index.js!../../node_modules/sass-loader/index.js!./app.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(348)();
	// imports
	exports.push([module.id, "@import url(http://fonts.googleapis.com/css?family=Montserrat:400,700,200);", ""]);
	exports.push([module.id, "@import url(http://fonts.googleapis.com/css?family=Lato);", ""]);
	
	// module
	exports.push([module.id, ".sk-cube-grid{width:40px;height:40px;position:absolute;top:50%;left:0;right:0;margin:-20px auto 0;z-index:1001}.sk-cube-grid:before{content:\"\";position:fixed;top:0;left:0;width:100%;height:100%;bottom:0;background-color:hsla(0,0%,100%,.7)}.sk-cube-grid .sk-cube{width:33%;height:33%;background-color:#f96332;float:left;-webkit-animation:sk-cubeGridScaleDelay 1.3s infinite ease-in-out;animation:sk-cubeGridScaleDelay 1.3s infinite ease-in-out}.sk-cube-grid .sk-cube1{-webkit-animation-delay:.2s;animation-delay:.2s}.sk-cube-grid .sk-cube2{-webkit-animation-delay:.3s;animation-delay:.3s}.sk-cube-grid .sk-cube3{-webkit-animation-delay:.4s;animation-delay:.4s}.sk-cube-grid .sk-cube4{-webkit-animation-delay:.1s;animation-delay:.1s}.sk-cube-grid .sk-cube5{-webkit-animation-delay:.2s;animation-delay:.2s}.sk-cube-grid .sk-cube6{-webkit-animation-delay:.3s;animation-delay:.3s}.sk-cube-grid .sk-cube7{-webkit-animation-delay:0s;animation-delay:0s}.sk-cube-grid .sk-cube8{-webkit-animation-delay:.1s;animation-delay:.1s}.sk-cube-grid .sk-cube9{-webkit-animation-delay:.2s;animation-delay:.2s}@-webkit-keyframes sk-cubeGridScaleDelay{0%,70%,to{-webkit-transform:scale3D(1,1,1);transform:scale3D(1,1,1)}35%{-webkit-transform:scale3D(0,0,1);transform:scale3D(0,0,1)}}@keyframes sk-cubeGridScaleDelay{0%,70%,to{-webkit-transform:scale3D(1,1,1);transform:scale3D(1,1,1)}35%{-webkit-transform:scale3D(0,0,1);transform:scale3D(0,0,1)}}.fade.in{opacity:1}.modal.in .modal-dialog{-webkit-transform:translate(0);transform:translate(0)}.modal-backdrop.in{filter:alpha(opacity=50);opacity:.5}body{height:100%;font-family:Lato,Helvetica Neue,Arial,sans-serif}.form-group{margin-bottom:10px}.form-control{font-size:1em}textarea.form-control{border-radius:15px;border:1px solid #e3e3e3}textarea.form-control:active,textarea.form-control:focus{border:1px solid #f96332}.clickable{cursor:pointer}form.submitted .ng-invalid{border-color:#f96332}.app{height:100%}", ""]);
	
	// exports


/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _angular = __webpack_require__(368);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _imageDetail = __webpack_require__(494);
	
	var _imageDetail2 = _interopRequireDefault(_imageDetail);
	
	var _confirmDialog = __webpack_require__(503);
	
	var _confirmDialog2 = _interopRequireDefault(_confirmDialog);
	
	var _reportImages = __webpack_require__(509);
	
	var _reportImages2 = _interopRequireDefault(_reportImages);
	
	var _reportMap = __webpack_require__(515);
	
	var _reportMap2 = _interopRequireDefault(_reportMap);
	
	var _flora = __webpack_require__(521);
	
	var _flora2 = _interopRequireDefault(_flora);
	
	var _model = __webpack_require__(523);
	
	var _model2 = _interopRequireDefault(_model);
	
	var _dynamicModel = __webpack_require__(531);
	
	var _dynamicModel2 = _interopRequireDefault(_dynamicModel);
	
	var _isNumericArray = __webpack_require__(532);
	
	var _isNumericArray2 = _interopRequireDefault(_isNumericArray);
	
	var _language = __webpack_require__(534);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _dots = __webpack_require__(536);
	
	var _dots2 = _interopRequireDefault(_dots);
	
	var _noHTML = __webpack_require__(538);
	
	var _noHTML2 = _interopRequireDefault(_noHTML);
	
	var _camelToKebab = __webpack_require__(540);
	
	var _camelToKebab2 = _interopRequireDefault(_camelToKebab);
	
	var _snakeToSpace = __webpack_require__(542);
	
	var _snakeToSpace2 = _interopRequireDefault(_snakeToSpace);
	
	var _resource = __webpack_require__(544);
	
	var _resource2 = _interopRequireDefault(_resource);
	
	var _user = __webpack_require__(546);
	
	var _user2 = _interopRequireDefault(_user);
	
	var _auth = __webpack_require__(548);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _information = __webpack_require__(550);
	
	var _information2 = _interopRequireDefault(_information);
	
	var _geojsonBuilder = __webpack_require__(552);
	
	var _geojsonBuilder2 = _interopRequireDefault(_geojsonBuilder);
	
	var _util = __webpack_require__(554);
	
	var _util2 = _interopRequireDefault(_util);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var commonModule = _angular2.default.module('app.common', [_imageDetail2.default, _confirmDialog2.default, _flora2.default, _dots2.default, _noHTML2.default, _camelToKebab2.default, _snakeToSpace2.default, _model2.default, _language2.default, _dynamicModel2.default, _isNumericArray2.default, _resource2.default, _user2.default, _auth2.default, _information2.default, _geojsonBuilder2.default, _util2.default, _reportImages2.default, _reportMap2.default]).name;
	
	exports.default = commonModule;

/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(368);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(370);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _imageDetail = __webpack_require__(495);
	
	var _imageDetail2 = _interopRequireDefault(_imageDetail);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var imageDetailModule = _angular2.default.module('imageDetail', [_angularUiRouter2.default])
	
	// .config(($stateProvider) => {
	//   "ngInject";
	//   $stateProvider
	//   .state('imageDetail', {
	//     url: '/imageDetail',
	//     component: 'imageDetail'
	//   });
	// })
	
	.component('imageDetail', _imageDetail2.default).name;
	
	exports.default = imageDetailModule;

/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _imageDetail = __webpack_require__(496);
	
	var _imageDetail2 = _interopRequireDefault(_imageDetail);
	
	var _imageDetail3 = __webpack_require__(497);
	
	var _imageDetail4 = _interopRequireDefault(_imageDetail3);
	
	__webpack_require__(501);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var imageDetailComponent = {
	  bindings: {
	    resolve: '<',
	    close: '&',
	    dismiss: '&'
	  },
	  template: _imageDetail2.default,
	  controller: _imageDetail4.default,
	  controllerAs: "vm"
	};
	
	exports.default = imageDetailComponent;

/***/ }),
/* 496 */
/***/ (function(module, exports) {

	module.exports = "<img class=\"img img-responsive\"\r\n     ng-src=\"{{vm.imageSource}}\">\r\n<div class=\"modal-footer\">\r\n  <button class=\"btn btn-default btn-round\"\r\n          ng-click=\"vm.deleteImage()\">Cancella immagine\r\n  </button>\r\n  <button class=\"btn btn-primary btn-round\"\r\n          ng-click=\"vm.dismiss()\"><span class=\"ti ti-close\"></span> Chiudi\r\n  </button>\r\n</div>\r\n"

/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(498);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _lodash = __webpack_require__(499);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageDetailController = function ImageDetailController(Image, $uibModal) {
	  "ngInject";
	
	  (0, _classCallCheck3.default)(this, ImageDetailController);
	  var vm = this;
	  vm.$onInit = function () {
	    if (vm.resolve && vm.resolve.imageSource) {
	      vm.imageSource = vm.resolve.imageSource;
	    }
	  };
	
	  vm.deleteImage = function () {
	    $uibModal.open({
	      component: 'confirmDialog',
	      windowClass: 'modal-mini modal-primary',
	      resolve: {
	        message: function message() {
	          return "Confermi di voler cancellare l'immagine selezionata?";
	        }
	      }
	    }).result.then(function () {
	      Image.deleteImage(vm.resolve.imageId).then(function () {
	        if (_lodash2.default.isFunction(vm.resolve.callback)) {
	          vm.resolve.callback();
	          vm.close();
	        }
	      });
	    });
	  };
	};
	ImageDetailController.$inject = ["Image", "$uibModal"];
	
	exports.default = ImageDetailController;

/***/ }),
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(502);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(349)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./imageDetail.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./imageDetail.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(348)();
	// imports
	
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(368);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(370);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _confirmDialog = __webpack_require__(504);
	
	var _confirmDialog2 = _interopRequireDefault(_confirmDialog);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var confirmDialogModule = _angular2.default.module('confirmDialog', [_angularUiRouter2.default]).component('confirmDialog', _confirmDialog2.default).name;
	
	exports.default = confirmDialogModule;

/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _confirmDialog = __webpack_require__(505);
	
	var _confirmDialog2 = _interopRequireDefault(_confirmDialog);
	
	var _confirmDialog3 = __webpack_require__(506);
	
	var _confirmDialog4 = _interopRequireDefault(_confirmDialog3);
	
	__webpack_require__(507);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var confirmDialogComponent = {
	  bindings: {
	    close: '&',
	    dismiss: '&',
	    resolve: '<'
	  },
	  template: _confirmDialog2.default,
	  controller: _confirmDialog4.default,
	  controllerAs: "vm"
	};
	
	exports.default = confirmDialogComponent;

/***/ }),
/* 505 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header justify-content-center\">\r\n  <div class=\"modal-profile\">\r\n    <!--<i class=\"now-ui-icons travel_info\"></i>-->\r\n    <i class=\"ti ti-check\"></i>\r\n  </div>\r\n</div>\r\n<div class=\"modal-body\">\r\n  <p>{{vm.resolve.message || \"Confermi l'azione?\"}}</p>\r\n</div>\r\n<div class=\"modal-footer\">\r\n  <button type=\"button\"\r\n          class=\"btn btn-link btn-neutral\"\r\n          ng-click=\"vm.dismiss()\">Chiudi\r\n  </button>\r\n  <button type=\"button\"\r\n          class=\"btn btn-link btn-neutral\"\r\n          ng-click=\"vm.close()\">Conferma\r\n  </button>\r\n</div>\r\n"

/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(498);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ConfirmDialogController = function ConfirmDialogController() {
	  "ngInject";
	
	  (0, _classCallCheck3.default)(this, ConfirmDialogController);
	  var vm = this;
	  vm.name = 'confirmDialog';
	};
	
	exports.default = ConfirmDialogController;

/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(508);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(349)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./confirmDialog.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./confirmDialog.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(348)();
	// imports
	
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _angular = __webpack_require__(368);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(370);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _reportImages = __webpack_require__(510);
	
	var _reportImages2 = _interopRequireDefault(_reportImages);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var reportImagesModule = _angular2.default.module('reportImages', [_angularUiRouter2.default]).component('reportImages', _reportImages2.default).name;
	
	exports.default = reportImagesModule;

/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reportImages = __webpack_require__(511);
	
	var _reportImages2 = _interopRequireDefault(_reportImages);
	
	var _reportImages3 = __webpack_require__(512);
	
	var _reportImages4 = _interopRequireDefault(_reportImages3);
	
	__webpack_require__(513);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var reportImagesComponent = {
	  bindings: {
	    resolve: '<',
	    close: '&',
	    dismiss: '&'
	  },
	  template: _reportImages2.default,
	  controller: _reportImages4.default,
	  controllerAs: "vm"
	};
	
	exports.default = reportImagesComponent;

/***/ }),
/* 511 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\r\n    <button type=\"button\"\r\n            class=\"close\"\r\n            data-dismiss=\"modal\"\r\n            ng-click=\"vm.dismiss()\">&times;\r\n    </button>\r\n    <h4 class=\"modal-title\">Immagini allegate</h4>\r\n</div>\r\n<div class=\"modal-body\">\r\n    <div class=\"row\">\r\n        <div ng-repeat=\"img in vm.images\"\r\n             class=\"col-sm-6 col-md-6 col-lg-4\"\r\n             ng-class=\"{'col-md-12 col-lg-12 col-sm-12': vm.zoom[$index]}\">\r\n            <div class=\"text-right\">\r\n                <button class=\"btn btn-sm btn-default\"\r\n                        ng-if=\"!vm.zoom[$index]\"\r\n                        ng-click=\"vm.zoom[$index] = true\">Ingrandisci\r\n                </button>\r\n                <button class=\"btn btn-sm btn-default\"\r\n                        ng-if=\"!!vm.zoom[$index]\"\r\n                        ng-click=\"vm.zoom[$index] = false\">Riduci\r\n                </button>\r\n            </div>\r\n            <img class=\"img img-responsive\"\r\n                 ng-src=\"{{img}}\">\r\n        </div>\r\n    </div>\r\n</div>\r\n<div class=\"modal-footer text-right\">\r\n    <!--<button class=\"btn btn-default btn-round\"\r\n            ng-click=\"vm.deleteImage()\">Cancella immagine\r\n    </button>-->\r\n    <button class=\"btn btn-primary btn-round\"\r\n            ng-click=\"vm.dismiss()\"><span class=\"ti ti-close\"></span> Chiudi\r\n    </button>\r\n</div>\r\n"

/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(498);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ReportImagesController = function ReportImagesController() {
	  "ngInject";
	
	  (0, _classCallCheck3.default)(this, ReportImagesController);
	  var vm = this;
	  vm.images = [];
	  vm.zoom = [];
	
	  vm.$onInit = function () {
	    if (vm.resolve && vm.resolve.images) {
	      vm.images = vm.resolve.images;
	    }
	  };
	};
	
	exports.default = ReportImagesController;

/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(514);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(349)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./reportImages.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./reportImages.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(348)();
	// imports
	
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(368);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(370);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _reportMap = __webpack_require__(516);
	
	var _reportMap2 = _interopRequireDefault(_reportMap);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var reportMapModule = _angular2.default.module('reportMap', [_angularUiRouter2.default])
	
	// .config(($stateProvider) => {
	//   "ngInject";
	//   $stateProvider
	//   .state('reportMap', {
	//     url: '/reportMap',
	//     component: 'reportMap'
	//   });
	// })
	
	.component('reportMap', _reportMap2.default).name;
	
	exports.default = reportMapModule;

/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reportMap = __webpack_require__(517);
	
	var _reportMap2 = _interopRequireDefault(_reportMap);
	
	var _reportMap3 = __webpack_require__(518);
	
	var _reportMap4 = _interopRequireDefault(_reportMap3);
	
	__webpack_require__(519);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var reportMapComponent = {
	    bindings: {
	        resolve: '<',
	        close: '&',
	        dismiss: '&'
	    },
	    template: _reportMap2.default,
	    controller: _reportMap4.default,
	    controllerAs: "vm"
	};
	
	exports.default = reportMapComponent;

/***/ }),
/* 517 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\r\n  <button type=\"button\"\r\n          class=\"close\"\r\n          data-dismiss=\"modal\"\r\n          ng-click=\"vm.dismiss()\">&times;\r\n  </button>\r\n  <h4 class=\"modal-title\">Geolocalizzazione della segnalazione</h4>\r\n</div>\r\n<div class=\"modal-body\">\r\n  <div class=\"reportMap\" id=\"reportMap\">\r\n\r\n  </div>\r\n</div>\r\n<div class=\"modal-footer text-right\">\r\n  <!--<button class=\"btn btn-default btn-round\"\r\n          ng-click=\"vm.deleteImage()\">Cancella immagine\r\n  </button>-->\r\n  <button class=\"btn btn-primary btn-round\"\r\n          ng-click=\"vm.dismiss()\"><span class=\"ti ti-close\"></span> Chiudi\r\n  </button>\r\n</div>\r\n\r\n"

/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(498);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ReportMapController = function ReportMapController($timeout) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, ReportMapController);
	    var vm = this;
	    vm.map = null;
	    vm.$onInit = init;
	
	    function init() {
	        if (vm.resolve && vm.resolve.report) {
	            vm.report = vm.resolve.report;
	
	            if (!!vm.report.latitude && !!vm.report.longitude) {
	                console.log("Report ", vm.report);
	                $timeout(function () {
	                    initMap();
	                    addMarker();
	                }, 0);
	            }
	        }
	    }
	
	    function initMap() {
	        vm.map = L.map('reportMap').setView([vm.report.latitude, vm.report.longitude], 16);
	        L.tileLayer('https://api.tiles.mapbox.com/v4/{id}/{z}/{x}/{y}.png?access_token={accessToken}', {
	            attribution: '<a href="http://openstreetmap.org">OpenStreetMap</a> | <a href="http://mapbox.com">Mapbox</a>',
	            maxZoom: 21,
	            id: 'mapbox.streets',
	            accessToken: 'pk.eyJ1IjoibWFpbHZpcm9vcyIsImEiOiJjajlkNnJ6bnQxeDFwMnFveW9hcHJ6NGI4In0.81GT3m2HWbB2efieELsj8Q',
	            zoomAnimation: true
	        }).addTo(vm.map);
	    }
	
	    function addMarker() {
	        L.marker([vm.report.latitude, vm.report.longitude], {
	            icon: L.icon({
	                iconUrl: 'assets/img/pin.png',
	                iconSize: [29.5, 40],
	                iconAnchor: [15, 40]
	            })
	        }).addTo(vm.map);
	    }
	};
	ReportMapController.$inject = ["$timeout"];
	
	exports.default = ReportMapController;

/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(520);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(349)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./reportMap.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./reportMap.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(348)();
	// imports
	
	
	// module
	exports.push([module.id, ".reportMap{width:100%;height:400px}", ""]);
	
	// exports


/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(368);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _flora = __webpack_require__(522);
	
	var _flora2 = _interopRequireDefault(_flora);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var floraModule = _angular2.default.module('flora.service', []).service('Flora', _flora2.default).name;
	
	exports.default = floraModule;

/***/ }),
/* 522 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var Flora = function Flora($http, SERVER_URL) {
	  "ngInject";
	
	  return {
	    getList: getList,
	    get: get,
	    getTypes: getTypes,
	    put: put,
	    putStrings: putStrings,
	    postStrings: postStrings
	  };
	
	  function getList() {
	    return $http.get(SERVER_URL + "/flora-by-modified-date", {
	      params: { modifiedDate: "2010-10-31T00:49:30.995Z" }
	    });
	  }
	
	  function get(id) {
	    return $http.get(SERVER_URL + "/flora/" + id);
	  }
	
	  function getTypes() {
	    return ['PTERIDOFITE', 'SPERMATOFITE_ANGIOSPERME', 'SPERMATOFITE_GIMNOSPERME', 'ALTRO'];
	  }
	
	  function put(data) {
	    return $http.put(SERVER_URL + "/flora", data);
	  }
	
	  function postStrings(data) {
	    return $http.post(SERVER_URL + "/flora-strings", data);
	  }
	
	  function putStrings(data) {
	    return $http.put(SERVER_URL + "/flora-strings", data);
	  }
	};
	Flora.$inject = ["$http", "SERVER_URL"];
	exports.default = Flora;

/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(368);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _model = __webpack_require__(524);
	
	var _model2 = _interopRequireDefault(_model);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var modelModule = _angular2.default.module('model.factory', []).factory('ModelFactory', _model2.default).name;
	
	exports.default = modelModule;

/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _culture = __webpack_require__(525);
	
	var _culture2 = _interopRequireDefault(_culture);
	
	var _nature = __webpack_require__(526);
	
	var _nature2 = _interopRequireDefault(_nature);
	
	var _outdoor = __webpack_require__(527);
	
	var _outdoor2 = _interopRequireDefault(_outdoor);
	
	var _service = __webpack_require__(528);
	
	var _service2 = _interopRequireDefault(_service);
	
	var _typicalProduct = __webpack_require__(529);
	
	var _typicalProduct2 = _interopRequireDefault(_typicalProduct);
	
	var _itinerary = __webpack_require__(530);
	
	var _itinerary2 = _interopRequireDefault(_itinerary);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Model = function Model() {
	  'ngInject';
	
	  return {
	    getModelsConstant: getModelsConstant,
	    getByEnum: getByEnum,
	    getModel: getModel,
	    getNatureStructure: getNatureStructure,
	    getOutdoorStructure: getOutdoorStructure,
	    getCultureStructure: getCultureStructure,
	    getServiceStructure: getServiceStructure,
	    getTypicalProductStructure: getTypicalProductStructure,
	    getItineraryStructure: getItineraryStructure
	
	    /**
	     *Enum: usato per caricare le immagini su s3
	     * Name: usato per l'ng-model (in nome del campo tornato dal server)
	     */
	  };function getModelsConstant() {
	    return {
	      CULTURE: { enum: 'CULTURE', name: 'culture' },
	      ITINERARY: { enum: 'ITINERARY', name: 'itinerary' },
	      INFORMATION: { enum: 'INFORMATION', name: 'information' },
	      NATURE: { enum: 'NATURE', name: 'nature' },
	      TYPICALPRODUCT: { enum: 'TYPICALPRODUCT', name: 'typicalProduct' },
	      SERVICE: { enum: 'SERVICE', name: 'service' },
	      OUTDOOR: { enum: 'OUTDOOR', name: 'outdoor' }
	    };
	  }
	
	  function getByEnum(modelEnum) {
	    var models = getModelsConstant();
	    if (_.has(models, modelEnum)) {
	      return _.get(models, modelEnum);
	    }
	    throw 'Unknown model type';
	  }
	
	  function getModel(serverResponce) {
	    if (_.has(serverResponce, 'culture')) return getModelsConstant().CULTURE;else if (_.has(serverResponce, 'information')) {
	      return getModelsConstant().INFORMATION;
	    } else if (_.has(serverResponce, 'itinerary')) {
	      return getModelsConstant().ITINERARY;
	    } else if (_.has(serverResponce, 'nature')) {
	      return getModelsConstant().NATURE;
	    } else if (_.has(serverResponce, 'typicalProduct')) {
	      return getModelsConstant().TYPICALPRODUCT;
	    } else if (_.has(serverResponce, 'service')) {
	      return getModelsConstant().SERVICE;
	    } else if (_.has(serverResponce, 'outdoor')) {
	      return getModelsConstant().OUTDOOR;
	    } else {
	      throw 'Unknown model type';
	    }
	  }
	
	  function getCultureStructure() {
	    return _culture2.default;
	  }
	  function getNatureStructure() {
	    return _nature2.default;
	  }
	  function getOutdoorStructure() {
	    return _outdoor2.default;
	  }
	  function getServiceStructure() {
	    return _service2.default;
	  }
	  function getTypicalProductStructure() {
	    return _typicalProduct2.default;
	  }
	  function getItineraryStructure() {
	    return _itinerary2.default;
	  }
	};
	
	exports.default = Model;

/***/ }),
/* 525 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var culture = {
	  'model': {
	
	    'cultureType': {
	      'title': 'Sottomenù',
	      'type': 'select',
	      'enum': ['BORGHI_STORICI', 'EDIFICI', 'MUSEI', 'OPERE_DARTE'],
	      'prefix': 'vm.item.culture',
	      'required': true
	    },
	
	    'title': {
	      'title': 'Titolo',
	      'type': 'input',
	      'prefix': 'lang',
	      'required': true
	    },
	
	    'municipality': {
	      'title': 'Comune',
	      'type': 'input',
	      'prefix': 'vm.item.culture',
	      'required': false
	    },
	
	    'category': {
	      'title': 'Categoria',
	      'type': 'input',
	      'prefix': 'vm.item.culture',
	      'required': false
	    },
	
	    'phoneNumber': {
	      'title': 'Numero di telefono',
	      'type': 'input',
	      'prefix': 'vm.item.culture'
	    },
	
	    'eMail': {
	      'title': 'E-mail',
	      'type': 'input',
	      'prefix': 'vm.item.culture'
	    },
	
	    'webSite': {
	      'title': 'Sito web',
	      'type': 'input',
	      'prefix': 'vm.item.culture'
	    },
	
	    'description': {
	      'title': 'Descrizione',
	      // 'type': 'textarea',
	      'type': 'editor',
	      'prefix': 'lang',
	      'row': 8
	    },
	
	    'location': {
	      'title': 'Ubicazione',
	      'type': 'input',
	      'prefix': 'lang',
	      'required': true
	    },
	
	    'timetable': {
	      'title': 'Orari e stagionalità',
	      'type': 'input',
	      'prefix': 'lang'
	    },
	
	    'note': {
	      'title': 'Note',
	      'type': 'editor',
	      'prefix': 'lang',
	      'row': 2
	    },
	
	    'additionalInformations': {
	      'title': 'Approfondisci',
	      'type': 'editor',
	      'prefix': 'lang',
	      'row': 2
	    }
	  }
	};
	
	exports.default = culture;

/***/ }),
/* 526 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var culture = {
	  'model': {
	
	    'natureType': {
	      'title': 'Sottomenù',
	      'type': 'select',
	      'enum': ['FLORA', 'FAUNA', 'HABITAT', 'GEOLOGIA'],
	      'prefix': 'vm.item.nature',
	      'required': true
	    },
	
	    'title': {
	      'title': 'Titolo',
	      'type': 'input',
	      'prefix': 'lang',
	      'required': true
	    },
	
	    'municipality': {
	      'title': 'Comune',
	      'type': 'input',
	      'prefix': 'vm.item.nature',
	      'required': false
	    },
	
	    'category': {
	      'title': 'Categoria',
	      'type': 'input',
	      'prefix': 'vm.item.nature',
	      'required': false
	    },
	
	    'phoneNumber': {
	      'title': 'Numero di telefono',
	      'type': 'input',
	      'prefix': 'vm.item.nature'
	    },
	
	    'eMail': {
	      'title': 'E-mail',
	      'type': 'input',
	      'prefix': 'vm.item.nature'
	    },
	
	    'webSite': {
	      'title': 'Sito web',
	      'type': 'input',
	      'prefix': 'vm.item.nature'
	    },
	
	    'description': {
	      'title': 'Descrizione',
	      'type': 'editor',
	      'prefix': 'lang',
	      'row': 8
	    },
	
	    'location': {
	      'title': 'Ubicazione',
	      'type': 'input',
	      'prefix': 'lang',
	      'required': true
	    },
	
	    'timetable': {
	      'title': 'Orari e stagionalità',
	      'type': 'input',
	      'prefix': 'lang'
	    },
	
	    'note': {
	      'title': 'Note',
	      'type': 'editor',
	      'prefix': 'lang',
	      'row': 2
	    },
	
	    'additionalInformations': {
	      'title': 'Approfondisci',
	      'type': 'editor',
	      'prefix': 'lang',
	      'row': 2
	    }
	  }
	};
	
	exports.default = culture;

/***/ }),
/* 527 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var culture = {
	  'model': {
	
	    'outdoorType': {
	      'title': 'Sottomenù',
	      'type': 'select',
	      'enum': ['ARRAMPICATA', 'CANYONING', 'CIASPOLE', 'PROPOSTE_ESPERIENZIALI'],
	      'prefix': 'vm.item.outdoor',
	      'required': true
	    },
	
	    'title': {
	      'title': 'Titolo',
	      'type': 'input',
	      'prefix': 'lang',
	      'required': true
	    },
	
	    'municipality': {
	      'title': 'Comune',
	      'type': 'input',
	      'prefix': 'vm.item.outdoor',
	      'required': false
	    },
	
	    'category': {
	      'title': 'Categoria',
	      'type': 'input',
	      'prefix': 'vm.item.outdoor',
	      'required': false
	    },
	
	    'phoneNumber': {
	      'title': 'Numero di telefono',
	      'type': 'input',
	      'prefix': 'vm.item.outdoor'
	    },
	
	    'eMail': {
	      'title': 'E-mail',
	      'type': 'input',
	      'prefix': 'vm.item.outdoor'
	    },
	
	    'webSite': {
	      'title': 'Sito web',
	      'type': 'input',
	      'prefix': 'vm.item.outdoor'
	    },
	
	    'description': {
	      'title': 'Descrizione',
	      'type': 'editor',
	      'prefix': 'lang',
	      'row': 8
	    },
	
	    'location': {
	      'title': 'Ubicazione',
	      'type': 'input',
	      'prefix': 'lang',
	      'required': true
	    },
	
	    'timetable': {
	      'title': 'Orari e stagionalità',
	      'type': 'input',
	      'prefix': 'lang'
	    },
	
	    'note': {
	      'title': 'Note',
	      'type': 'editor',
	      'prefix': 'lang',
	      'row': 2
	    },
	
	    'additionalInformations': {
	      'title': 'Approfondisci',
	      'type': 'editor',
	      'prefix': 'lang',
	      'row': 2
	    }
	  }
	};
	
	exports.default = culture;

/***/ }),
/* 528 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var culture = {
	  'model': {
	
	    'serviceType': {
	      'title': 'Sottomenù',
	      'type': 'select',
	      'enum': ['INFO_TURISMO', 'GUIDE', 'RISTORAZIONE', 'DORMIRE', 'NUMERI_UTILI', 'TOUR_OPERATOR'],
	      'prefix': 'vm.item.service',
	      'required': true
	    },
	
	    'title': {
	      'title': 'Titolo',
	      'type': 'input',
	      'prefix': 'lang',
	      'required': true
	    },
	
	    'municipality': {
	      'title': 'Comune',
	      'type': 'input',
	      'prefix': 'vm.item.service',
	      'required': false
	    },
	
	    'category': {
	      'title': 'Categoria',
	      'type': 'input',
	      'prefix': 'vm.item.service',
	      'required': false
	    },
	
	    'phoneNumber': {
	      'title': 'Numero di telefono',
	      'type': 'input',
	      'prefix': 'vm.item.service'
	    },
	
	    'eMail': {
	      'title': 'E-mail',
	      'type': 'input',
	      'prefix': 'vm.item.service'
	    },
	
	    'webSite': {
	      'title': 'Sito web',
	      'type': 'input',
	      'prefix': 'vm.item.service'
	    },
	
	    'description': {
	      'title': 'Descrizione',
	      'type': 'editor',
	      'prefix': 'lang',
	      'row': 8
	    },
	
	    'location': {
	      'title': 'Ubicazione',
	      'type': 'input',
	      'prefix': 'lang',
	      'required': true
	    },
	
	    'timetable': {
	      'title': 'Orari e stagionalità',
	      'type': 'input',
	      'prefix': 'lang'
	    },
	
	    'note': {
	      'title': 'Note',
	      'type': 'editor',
	      'prefix': 'lang',
	      'row': 2
	    },
	
	    'additionalInformations': {
	      'title': 'Approfondisci',
	      'type': 'editor',
	      'prefix': 'lang',
	      'row': 2
	    }
	  }
	};
	
	exports.default = culture;

/***/ }),
/* 529 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var culture = {
	  'model': {
	    'typicalProductType': {
	      'title': 'Sottomenù',
	      'type': 'select',
	      'enum': ['DOVE_TROVARLI', 'ELENCO'],
	      'prefix': 'vm.item.typicalProduct',
	      'required': true
	    },
	
	    'title': {
	      'title': 'Titolo',
	      'type': 'input',
	      'prefix': 'lang',
	      'required': true
	    },
	
	    'municipality': {
	      'title': 'Comune',
	      'type': 'input',
	      'prefix': 'vm.item.typicalProduct',
	      'required': false
	    },
	
	    'category': {
	      'title': 'Categoria',
	      'type': 'input',
	      'prefix': 'vm.item.typicalProduct',
	      'required': false
	    },
	
	    'phoneNumber': {
	      'title': 'Numero di telefono',
	      'type': 'input',
	      'prefix': 'vm.item.typicalProduct'
	    },
	
	    'eMail': {
	      'title': 'E-mail',
	      'type': 'input',
	      'prefix': 'vm.item.typicalProduct'
	    },
	
	    'webSite': {
	      'title': 'Sito web',
	      'type': 'input',
	      'prefix': 'vm.item.typicalProduct'
	    },
	
	    'description': {
	      'title': 'Descrizione',
	      'type': 'editor',
	      'prefix': 'lang',
	      'row': 8
	    },
	
	    'location': {
	      'title': 'Ubicazione',
	      'type': 'input',
	      'prefix': 'lang',
	      'required': true
	    },
	
	    'timetable': {
	      'title': 'Orari e stagionalità',
	      'type': 'input',
	      'prefix': 'lang'
	    },
	
	    'note': {
	      'title': 'Note',
	      'type': 'editor',
	      'prefix': 'lang',
	      'row': 2
	    },
	
	    'additionalInformations': {
	      'title': 'Approfondisci',
	      'type': 'editor',
	      'prefix': 'lang',
	      'row': 2
	    }
	  }
	};
	
	exports.default = culture;

/***/ }),
/* 530 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var itinerary = {
	  'model': {
	
	    'itineraryType': {
	      'title': 'Sottomenù',
	      'type': 'select',
	      'enum': ['TREKKING', 'BICI'],
	      'prefix': 'vm.item.itinerary',
	      'required': true
	    },
	    'title': {
	      'title': 'Titolo',
	      'type': 'input',
	      'prefix': 'lang',
	      'required': true
	    },
	
	    'municipality': {
	      'title': 'Comune',
	      'type': 'input',
	      'prefix': 'vm.item.itinerary',
	      'required': false
	    },
	
	    'category': {
	      'title': 'Categoria',
	      'type': 'input',
	      'prefix': 'vm.item.itinerary',
	      'required': false
	    },
	
	    'phoneNumber': {
	      'title': 'Numero di telefono',
	      'type': 'input',
	      'prefix': 'vm.item.itinerary'
	    },
	
	    'eMail': {
	      'title': 'E-mail',
	      'type': 'input',
	      'prefix': 'vm.item.itinerary'
	    },
	
	    'webSite': {
	      'title': 'Sito web',
	      'type': 'input',
	      'prefix': 'vm.item.itinerary'
	    },
	
	    'description': {
	      'title': 'Descrizione',
	      'type': 'editor',
	      'prefix': 'lang',
	      'row': 8
	    },
	
	    'location': {
	      'title': 'Ubicazione',
	      'type': 'input',
	      'prefix': 'lang',
	      'required': true
	    },
	
	    'timetable': {
	      'title': 'Orari e stagionalità',
	      'type': 'input',
	      'prefix': 'lang'
	    },
	
	    'note': {
	      'title': 'Note',
	      'type': 'editor',
	      'prefix': 'lang',
	      'row': 2
	    },
	
	    'additionalInformations': {
	      'title': 'Approfondisci',
	      'type': 'editor',
	      'prefix': 'lang',
	      'row': 2
	    },
	
	    'geojson': {
	      'title': 'Geojson (Solamente la parte contenente le coordinate geografiche ad esempio [[7.98 , 10.25],[7.99, 10.26]]  )',
	      'type': 'numeric-array',
	      'prefix': 'vm.item.itinerary',
	      'row': 10,
	      'required': true
	    }
	
	  }
	};
	
	exports.default = itinerary;

/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(368);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var daynamicModel = _angular2.default.module('dynamicModel', []).directive('dynamicModel', ["$parse", "$compile", function ($parse, $compile) {
	  'ngInject';
	
	  return {
	    restrict: 'A',
	    terminal: true,
	    priority: 100000,
	    link: function link(scope, elem, attrs, ctrl) {
	      var name = $parse(elem.attr('dynamic-model'))(scope);
	      elem.removeAttr('dynamic-model');
	      elem.attr('ng-model', name);
	      $compile(elem)(scope);
	    }
	  };
	}]).name;
	
	exports.default = daynamicModel;

/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(368);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GJV = __webpack_require__(533);
	
	var isNumericArray = _angular2.default.module('isNumericArray', []).directive('isNumericArray', ["$parse", "$compile", "GeojsonBuilder", function ($parse, $compile, GeojsonBuilder) {
	  'ngInject';
	
	  return {
	    require: 'ngModel',
	    link: function link(scope, elem, attrs, ctrl) {
	
	      var active = $parse(elem.attr('is-numeric-array'))(scope);
	
	      if (active) {
	        scope.$watch(attrs.ngModel, function (value) {
	          if (!_.isNil(value)) {
	            var validGeojson = false;
	            try {
	              var geojsonArray = JSON.parse(value);
	
	              validGeojson = GJV.valid(GeojsonBuilder.getGeojson(geojsonArray));
	            } catch (e) {
	              console.log('invalid geojson format');
	            }
	            console.log('geojson validity: ' + validGeojson);
	            ctrl.$setValidity('numeric-array', validGeojson);
	          }
	        });
	      }
	    }
	  };
	}]).name;
	
	exports.default = isNumericArray;

/***/ }),
/* 533 */,
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(368);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _language = __webpack_require__(535);
	
	var _language2 = _interopRequireDefault(_language);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var languageModule = _angular2.default.module('language.factory', []).factory('LanguageFactory', _language2.default).name;
	
	exports.default = languageModule;

/***/ }),
/* 535 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var Language = function Language() {
	  'ngInject';
	
	  return {
	    getAvailableLanguageKeys: getAvailableLanguageKeys,
	    getDefaultLanguage: getDefaultLanguage
	  };
	
	  function getAvailableLanguageKeys() {
	    return ['IT', 'EN', 'DE', 'FR', 'NL'];
	  }
	
	  function getDefaultLanguage() {
	    return getAvailableLanguageKeys()[0];
	  }
	};
	
	exports.default = Language;

/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(368);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _dots = __webpack_require__(537);
	
	var _dots2 = _interopRequireDefault(_dots);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dotsModule = _angular2.default.module('dots.filter', []).filter('dots', _dots2.default).name;
	
	exports.default = dotsModule;

/***/ }),
/* 537 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var Dots = function Dots() {
	  return function (input, param) {
	    if (angular.isDefined(input) && !!input) {
	      if (param) {
	        return input.substring(0, parseInt(param)) + " ...";
	      }
	      return input.substring(0, 100) + " ...";
	    }
	  };
	};
	exports.default = Dots;

/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(368);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _noHTML = __webpack_require__(539);
	
	var _noHTML2 = _interopRequireDefault(_noHTML);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var noHTMLmodule = _angular2.default.module('noHTML.filter', []).filter('noHTML', _noHTML2.default).name;
	
	exports.default = noHTMLmodule;

/***/ }),
/* 539 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var noHTML = function noHTML() {
	
	  return function (text) {
	    return text ? String(text).replace(/<[^>]+>/gm, '') : '';
	  };
	};
	
	exports.default = noHTML;

/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(368);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _camelToKebab = __webpack_require__(541);
	
	var _camelToKebab2 = _interopRequireDefault(_camelToKebab);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var camelToKebabModule = _angular2.default.module('camelToKebab.filter', []).filter('camelToKebab', _camelToKebab2.default).name;
	
	exports.default = camelToKebabModule;

/***/ }),
/* 541 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var CamelToKebab = function CamelToKebab() {
	  return function (input, param) {
	    if (angular.isDefined(input)) {
	      return input.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
	    }
	  };
	};
	exports.default = CamelToKebab;

/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(368);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _snakeToSpace = __webpack_require__(543);
	
	var _snakeToSpace2 = _interopRequireDefault(_snakeToSpace);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var snakeToSpaceModule = _angular2.default.module('snakeToSpace.filter', []).filter('snakeToSpace', _snakeToSpace2.default).name;
	
	exports.default = snakeToSpaceModule;

/***/ }),
/* 543 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var SnakeToSpace = function SnakeToSpace() {
	  return function (input, param) {
	    if (angular.isDefined(input)) {
	      return input.replace(/_/g, " ").toLowerCase();
	    }
	  };
	};
	exports.default = SnakeToSpace;

/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(368);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _resource = __webpack_require__(545);
	
	var _resource2 = _interopRequireDefault(_resource);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var resourceModule = _angular2.default.module('resource.service', []).service('Resource', _resource2.default).name;
	
	exports.default = resourceModule;

/***/ }),
/* 545 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var Resource = function Resource($http, SERVER_URL, $filter) {
	  "ngInject";
	
	  return {
	    getList: getList,
	    get: get,
	    post: post,
	    put: put,
	    putGeoPoints: putGeoPoints,
	    postStrings: postStrings,
	    putStrings: putStrings,
	    remove: remove
	  };
	
	  function getList(modelName) {
	    modelName = $filter('camelToKebab')(modelName);
	    return $http.get(SERVER_URL + "/" + modelName + "-by-modified-date", {
	      params: { modifiedDate: "2010-10-31T00:49:30.995Z" }
	    });
	  }
	
	  function get(modelName, id) {
	    modelName = $filter('camelToKebab')(modelName);
	    return $http.get(SERVER_URL + "/" + modelName + "/" + id);
	  }
	
	  function put(modelName, data) {
	    modelName = $filter('camelToKebab')(modelName);
	    return $http.put(SERVER_URL + "/" + modelName, data);
	  }
	
	  function putGeoPoints(modelName, data) {
	    return $http.put(SERVER_URL + "/" + modelName + "/geo-points", data);
	  }
	
	  function post(modelName, data) {
	    modelName = $filter('camelToKebab')(modelName);
	    return $http.post(SERVER_URL + "/" + modelName, data);
	  }
	
	  function postStrings(modelName, data) {
	    modelName = $filter('camelToKebab')(modelName);
	    return $http.post(SERVER_URL + "/" + modelName + "-strings", data);
	  }
	
	  function putStrings(modelName, data) {
	    modelName = $filter('camelToKebab')(modelName);
	    return $http.put(SERVER_URL + "/" + modelName + "-strings", data);
	  }
	
	  function remove(modelName, id) {
	    modelName = $filter('camelToKebab')(modelName);
	    return $http.delete(SERVER_URL + "/" + modelName + "/" + id);
	  }
	};
	Resource.$inject = ["$http", "SERVER_URL", "$filter"];
	exports.default = Resource;

/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(368);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _user = __webpack_require__(547);
	
	var _user2 = _interopRequireDefault(_user);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var userModule = _angular2.default.module('user.service', []).service('User', _user2.default).name;
	
	exports.default = userModule;

/***/ }),
/* 547 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var User = function User($http, SERVER_URL) {
	  "ngInject";
	
	  return {
	    getList: getList
	  };
	
	  function getList(page, limit) {
	    if (!page) {
	      page = 0;
	    }
	    if (!limit) {
	      limit = 25;
	    }
	    return $http.get(SERVER_URL + "/users/mobile?page=" + page + "&size=" + limit);
	  }
	};
	User.$inject = ["$http", "SERVER_URL"];
	exports.default = User;

/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(368);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _auth = __webpack_require__(549);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var authModule = _angular2.default.module('auth.service', []).service('Auth', _auth2.default).name;
	
	exports.default = authModule;

/***/ }),
/* 549 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var Auth = function Auth($q, $state) {
	  "ngInject";
	
	  var service = this;
	
	  service.responseError = function (response) {
	    if (response.status == 401) {
	      // window.location = "/login";
	      $state.go("login");
	    }
	    return $q.reject(response);
	  };
	};
	Auth.$inject = ["$q", "$state"];
	exports.default = Auth;

/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(368);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _information = __webpack_require__(551);
	
	var _information2 = _interopRequireDefault(_information);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var informationModule = _angular2.default.module('information.service', []).service('Information', _information2.default).name;
	
	exports.default = informationModule;

/***/ }),
/* 551 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var Information = function Information($http, SERVER_URL) {
	  "ngInject";
	
	  return {
	    getList: getList,
	    post: post,
	    putString: putString,
	    deleteItem: deleteItem
	  };
	
	  function getList() {
	    return $http.get(SERVER_URL + "/information-by-modified-date", {
	      params: { modifiedDate: "2010-10-31T00:49:30.995Z" }
	    });
	  }
	
	  function post(item) {
	    return $http.post(SERVER_URL + "/information", item);
	  }
	
	  function putString(item) {
	    return $http.put(SERVER_URL + "/information-strings", item);
	  }
	
	  function deleteItem(item) {
	    return $http.delete(SERVER_URL + ("/information/" + item.id));
	  }
	};
	Information.$inject = ["$http", "SERVER_URL"];
	exports.default = Information;

/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(368);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _geojsonBuilder = __webpack_require__(553);
	
	var _geojsonBuilder2 = _interopRequireDefault(_geojsonBuilder);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var geojsonBuilderModule = _angular2.default.module('geojsonBuilder.service', []).service('GeojsonBuilder', _geojsonBuilder2.default).name;
	
	exports.default = geojsonBuilderModule;

/***/ }),
/* 553 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var GeojsonBuilder = function GeojsonBuilder() {
	  'ngInject';
	
	  return {
	    getGeojson: getGeojson
	  };
	
	  function getGeojson(geojsonArry) {
	    var geoJson = {
	      'type': 'FeatureCollection',
	      'features': [{
	        'type': 'Feature',
	        'properties': {},
	        'geometry': {
	          'type': 'MultiLineString',
	          'coordinates': [[]]
	        }
	      }]
	    };
	    geoJson.features[0].geometry.coordinates[0] = geojsonArry;
	    return geoJson;
	  }
	};
	exports.default = GeojsonBuilder;

/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(368);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _util = __webpack_require__(555);
	
	var _util2 = _interopRequireDefault(_util);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var utilModule = _angular2.default.module('util.service', []).service('Util', _util2.default).name;
	
	exports.default = utilModule;

/***/ }),
/* 555 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var Util = function Util() {
	  "ngInject";
	
	  return {
	    getSummernoteOptions: getSummernoteOptions
	  };
	
	  function getSummernoteOptions() {
	    return {
	      height: 300,
	      focus: false,
	      airMode: false,
	      toolbar: [['edit', ['undo', 'redo']], ['style', ['bold', 'italic', 'underline', 'strikethrough', 'clear']], ['textsize', ['fontsize']],
	      // ['fontclr', ['color']],
	      ['alignment', ['ul', 'ol', 'paragraph']], ['table', ['table']], ['insert', ['link', 'hr', 'picture']], ['view', ['codeview']]]
	    };
	  }
	};
	exports.default = Util;

/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(368);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _dashboard = __webpack_require__(557);
	
	var _dashboard2 = _interopRequireDefault(_dashboard);
	
	var _list = __webpack_require__(563);
	
	var _list2 = _interopRequireDefault(_list);
	
	var _detail = __webpack_require__(569);
	
	var _detail2 = _interopRequireDefault(_detail);
	
	var _description = __webpack_require__(575);
	
	var _description2 = _interopRequireDefault(_description);
	
	var _map = __webpack_require__(581);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _gallery = __webpack_require__(587);
	
	var _gallery2 = _interopRequireDefault(_gallery);
	
	var _comments = __webpack_require__(593);
	
	var _comments2 = _interopRequireDefault(_comments);
	
	var _users = __webpack_require__(599);
	
	var _users2 = _interopRequireDefault(_users);
	
	var _information = __webpack_require__(605);
	
	var _information2 = _interopRequireDefault(_information);
	
	var _addNew = __webpack_require__(611);
	
	var _addNew2 = _interopRequireDefault(_addNew);
	
	var _login = __webpack_require__(617);
	
	var _login2 = _interopRequireDefault(_login);
	
	var _confirmRegistration = __webpack_require__(623);
	
	var _confirmRegistration2 = _interopRequireDefault(_confirmRegistration);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var componentModule = _angular2.default.module('app.components', [_dashboard2.default, _list2.default, _detail2.default, _description2.default, _map2.default, _gallery2.default, _comments2.default, _users2.default, _information2.default, _addNew2.default, _login2.default, _confirmRegistration2.default]).name;
	
	exports.default = componentModule;

/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(368);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(370);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _dashboard = __webpack_require__(558);
	
	var _dashboard2 = _interopRequireDefault(_dashboard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dashboardModule = _angular2.default.module('dashboard', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('dashboard', {
	    url: '/main',
	    component: 'dashboard'
	  });
	}]).component('dashboard', _dashboard2.default).name;
	
	exports.default = dashboardModule;

/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _dashboard = __webpack_require__(559);
	
	var _dashboard2 = _interopRequireDefault(_dashboard);
	
	var _dashboard3 = __webpack_require__(560);
	
	var _dashboard4 = _interopRequireDefault(_dashboard3);
	
	__webpack_require__(561);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dashboardComponent = {
	  bindings: {},
	  template: _dashboard2.default,
	  controller: _dashboard4.default,
	  controllerAs: "vm"
	};
	
	exports.default = dashboardComponent;

/***/ }),
/* 559 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"dashboard\">\n  <div class=\"sidebar\">\n    <div class=\"logo\">\n      <img src=\"/assets/img/Logo-white.png\"\n           alt=\"\">\n    </div>\n\n    <div class=\"links\">\n      <div class=\"link\"\n           ui-sref=\"dashboard.list({modelEnum: 'CULTURE'})\"\n           ui-sref-active=\"active\">\n        Cultura\n      </div>\n      <div class=\"link\"\n           ui-sref=\"dashboard.list({modelEnum: 'NATURE'})\"\n           ui-sref-active=\"active\">\n        Natura viva\n      </div>\n      <div class=\"link\"\n           ui-sref=\"dashboard.list({modelEnum: 'TYPICALPRODUCT'})\"\n           ui-sref-active=\"active\">\n        Prodotti tipici\n      </div>\n      <div class=\"link\"\n           ui-sref=\"dashboard.list({modelEnum: 'SERVICE'})\"\n           ui-sref-active=\"active\">\n        Servizi e ricettività\n      </div>\n      <div class=\"link\"\n           ui-sref=\"dashboard.list({modelEnum: 'OUTDOOR'})\"\n           ui-sref-active=\"active\">\n        Outdoor\n      </div>\n\n      <div class=\"link\"\n           ui-sref=\"dashboard.list({modelEnum: 'ITINERARY'})\"\n           ui-sref-active=\"active\">\n        Itinerari (trekking, bici)\n      </div>\n\n      <div class=\"link\"\n           ui-sref=\"dashboard.users\">\n        Utenti\n      </div>\n      <div class=\"link\"\n           ui-sref=\"dashboard.comments\"\n           ui-sref-active=\"active\">\n        Segnalazioni e commenti\n      </div>\n      <div class=\"link\"\n           ui-sref=\"dashboard.information({modelEnum: 'INFORMATION'})\"\n           ui-sref-active=\"active\">\n        Informazioni\n      </div>\n      <!--<div class=\"link\"-->\n      <!--ui-sref=\"dashboard.cultura\"-->\n      <!--ui-sref-active=\"active\">-->\n      <!--&lt;!&ndash;<img src=\"/assets/icons/smartphone.png\"&ndash;&gt;-->\n      <!--&lt;!&ndash;class=\"icon\">&ndash;&gt;-->\n      <!--Segnalazioni-->\n      <!--</div>-->\n      <div class=\"link last\"\n           ui-sref=\"login\">\n        Logout\n      </div>\n    </div>\n\n  </div>\n\n  <div class=\"content-dashboard\">\n    <ui-view>\n\n    </ui-view>\n  </div>\n</div>\n"

/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(498);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DashboardController = function DashboardController() {
	  (0, _classCallCheck3.default)(this, DashboardController);
	
	  var vm = this;
	  vm.name = 'dashboard';
	};
	
	exports.default = DashboardController;

/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(562);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(349)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./dashboard.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./dashboard.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(348)();
	// imports
	exports.push([module.id, "@import url(http://fonts.googleapis.com/css?family=Montserrat:400,700,200);", ""]);
	exports.push([module.id, "@import url(http://fonts.googleapis.com/css?family=Lato);", ""]);
	
	// module
	exports.push([module.id, ".sk-cube-grid{width:40px;height:40px;position:absolute;top:50%;left:0;right:0;margin:-20px auto 0;z-index:1001}.sk-cube-grid:before{content:\"\";position:fixed;top:0;left:0;width:100%;height:100%;bottom:0;background-color:hsla(0,0%,100%,.7)}.sk-cube-grid .sk-cube{width:33%;height:33%;background-color:#f96332;float:left;-webkit-animation:sk-cubeGridScaleDelay 1.3s infinite ease-in-out;animation:sk-cubeGridScaleDelay 1.3s infinite ease-in-out}.sk-cube-grid .sk-cube1{-webkit-animation-delay:.2s;animation-delay:.2s}.sk-cube-grid .sk-cube2{-webkit-animation-delay:.3s;animation-delay:.3s}.sk-cube-grid .sk-cube3{-webkit-animation-delay:.4s;animation-delay:.4s}.sk-cube-grid .sk-cube4{-webkit-animation-delay:.1s;animation-delay:.1s}.sk-cube-grid .sk-cube5{-webkit-animation-delay:.2s;animation-delay:.2s}.sk-cube-grid .sk-cube6{-webkit-animation-delay:.3s;animation-delay:.3s}.sk-cube-grid .sk-cube7{-webkit-animation-delay:0s;animation-delay:0s}.sk-cube-grid .sk-cube8{-webkit-animation-delay:.1s;animation-delay:.1s}.sk-cube-grid .sk-cube9{-webkit-animation-delay:.2s;animation-delay:.2s}@-webkit-keyframes sk-cubeGridScaleDelay{0%,70%,to{-webkit-transform:scale3D(1,1,1);transform:scale3D(1,1,1)}35%{-webkit-transform:scale3D(0,0,1);transform:scale3D(0,0,1)}}@keyframes sk-cubeGridScaleDelay{0%,70%,to{-webkit-transform:scale3D(1,1,1);transform:scale3D(1,1,1)}35%{-webkit-transform:scale3D(0,0,1);transform:scale3D(0,0,1)}}.fade.in{opacity:1}.modal.in .modal-dialog{-webkit-transform:translate(0);transform:translate(0)}.modal-backdrop.in{filter:alpha(opacity=50);opacity:.5}body{height:100%;font-family:Lato,Helvetica Neue,Arial,sans-serif}.form-group{margin-bottom:10px}.form-control{font-size:1em}textarea.form-control{border-radius:15px;border:1px solid #e3e3e3}textarea.form-control:active,textarea.form-control:focus{border:1px solid #f96332}.clickable{cursor:pointer}form.submitted .ng-invalid{border-color:#f96332}.dashboard{background-color:transparent}.sidebar{width:200px;background-color:#22272a;color:#fff;position:fixed;top:0;left:0;bottom:0;font-family:Montserrat,sans-serif;overflow:auto}.sidebar .logo{width:100%;max-width:70px;height:auto;margin:20px auto}.sidebar .links{margin-top:40px}.sidebar .links .link{padding:15px;padding-left:20px;font-size:14px;position:relative;text-align:left;border-bottom:1px solid #2b3135}.sidebar .links .link.active,.sidebar .links .link:hover{border-right:#f96332;background-color:#f96332;background-color:rgba(249,99,50,.8);cursor:pointer;color:#fff}.sidebar .links .link.active{background-color:#f96332;border-right:4px solid #f14107}.sidebar .links .link .icon{position:absolute;left:10px}.sidebar .links .link.last{border-bottom:none}.content-dashboard{margin-left:200px;padding:0 20px}.section{padding:5px 0 40px}.card .tab-content{text-align:justify}.btn-link{border-radius:0}.btn-link.button-active{border-bottom:1px solid #f96332}", ""]);
	
	// exports


/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(368);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(370);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _list = __webpack_require__(564);
	
	var _list2 = _interopRequireDefault(_list);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var floraModule = _angular2.default.module('list', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('dashboard.list', {
	    url: '/list/:modelEnum',
	    component: 'resourceList',
	    params: {
	      modelEnum: null
	    }
	  });
	}]).component('resourceList', _list2.default).name;
	
	exports.default = floraModule;

/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _list = __webpack_require__(565);
	
	var _list2 = _interopRequireDefault(_list);
	
	var _list3 = __webpack_require__(566);
	
	var _list4 = _interopRequireDefault(_list3);
	
	__webpack_require__(567);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var floraComponent = {
	  bindings: {},
	  template: _list2.default,
	  controller: _list4.default,
	  controllerAs: "vm"
	};
	
	exports.default = floraComponent;

/***/ }),
/* 565 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"resource-list\">\n  <div class=\"section section-tabs\">\n    <div class=\"\">\n      <div class=\"row\">\n        <div class=\"col-sm-6\">\n          <button class=\"btn btn-primary btn-round\"\n                  ui-sref=\"dashboard.detail.description({id: 'new', modelType: vm.model, modelName: vm.model.name, modelEnum: vm.modelEnum})\"\n                  type=\"button\">\n            <i class=\"now-ui-icons ui-1_simple-add\"></i> Aggiungi nuovo\n          </button>\n        </div>\n        <div class=\"col-sm-6 text-right\">\n          <div class=\"row\">\n            <div class=\"col-sm-6\">\n              <span class=\"radio\">\n                <input type=\"radio\"\n                       name=\"viewType\"\n                       id=\"radio1\"\n                       value=\"grid\"\n                       ng-model=\"vm.viewType\"\n                >\n                <label for=\"radio1\">\n                  Griglia\n                </label>\n              </span>\n              <span class=\"radio\">\n                <input type=\"radio\"\n                       name=\"viewType\"\n                       id=\"radio2\"\n                       value=\"list\"\n                       ng-model=\"vm.viewType\">\n                <label for=\"radio2\">\n                  Lista\n                </label>\n              </span>\n            </div>\n            <div class=\"col-sm-6\">\n              <span class=\"input-group\">\n                <input type=\"text\"\n                       class=\"form-control\"\n                       ng-model=\"vm.searchFilter\"\n                       placeholder=\"Cerca per nome\">\n                <span class=\"input-group-addon\">\n                  <i class=\"now-ui-icons ui-1_zoom-bold\"></i>\n                </span>\n              </span>\n            </div>\n          </div>\n        </div>\n      </div>\n\n      <div class=\"row\">\n        <div class=\"col-sm-8\">\n          <h1>{{vm.modelEnum | translate}}</h1>\n        </div>\n        <div class=\"col-sm-4 text-right\">\n          <h6 class=\"text-primary\">trovati <strong>{{vm.items.length}}</strong> elementi</h6>\n        </div>\n        <div class=\"col-sm-12 col-md-6 col-lg-4\"\n             ng-class=\"{'col-md-12 col-lg-12': vm.viewType === 'list'}\"\n             ng-repeat=\"item in vm.items | filter:vm.searchFilter\">\n          <div class=\"card\">\n            <div class=\"card-body\">\n              <div class=\"row\">\n                <div class=\"col-sm-6 text-success\">\n                  <!--<span class=\"now-ui-icons ui-1_check\"></span> Visibile su app-->\n                </div>\n                <div class=\"col-sm-6 text-right\">\n                  <button\n                    ui-sref=\"dashboard.detail.description({id: $eval('item.'+vm.model.name+'.id'), modelType: vm.model, modelName: vm.model.name})\"\n                    class=\"btn btn-link btn-primary\">\n                    <i class=\"now-ui-icons travel_info\"></i> Dettagli\n                  </button>\n                  <!--<button class=\"btn btn-default btn-simple btn-round\"\n                          ui-sref=\"dashboard.detail\"\n                          type=\"button\">\n                    <i class=\"now-ui-icons travel_info\"></i> Dettagli\n                  </button>-->\n                </div>\n              </div>\n              <div ng-repeat=\"lang in $eval('item.'+vm.model.name+'StringsList')\"\n                   ng-if=\"lang.language == 'IT'\">\n                <h7><b>Sottocategoria: </b>{{$eval('item.'+vm.model.name+'.'+vm.model.name+'Type') | snakeToSpace}}</h7>\n                <br>\n                <h7><b>Comune: </b>{{$eval('item.'+vm.model.name+'.municipality')}}</h7>\n                <h6>\n                  {{ lang.name }}\n                </h6>\n                <b class=\"text-justify\">{{ lang.title }}</b><br><br>\n                <!-- <p class=\"text-justify\">{{ lang.description | noHTML | dots:vm.dots }}</p> -->\n              </div>\n              <div class=\"row text-muted features\">\n                <div class=\"col-sm-2\">\n                  <strong class=\"fa fa-picture-o\"></strong>{{ item.images.length }}\n                </div>\n                <div class=\"col-sm-2\">\n                  <strong class=\"fa fa-map-marker\"></strong>{{ item.geoPoints.length }}\n                </div>\n                <div class=\"col-sm-12 last-modify\">\n                  <br>\n                  <span class=\"text-muted\">Ultima modifica: {{ $eval('item.'+vm.model.name+'.modifiedDate') | date:'d MMM yyyy HH:mm' }}</span>\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(498);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _lodash = __webpack_require__(499);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ListController = function ListController(ModelFactory, $stateParams, Resource, $scope) {
	  "ngInject";
	
	  (0, _classCallCheck3.default)(this, ListController);
	  var vm = this;
	  vm.name = '';
	  vm.viewType = "grid"; //grid | list
	  vm.model = {};
	  vm.modelEnum = "";
	  vm.items = [];
	  vm.dots = 200;
	  init();
	
	  function init() {
	    vm.model = ModelFactory.getByEnum($stateParams.modelEnum);
	    vm.modelEnum = $stateParams.modelEnum;
	
	    Resource.getList(vm.model.name).then(function (res) {
	      console.log("Resource:", res.data);
	      vm.items = _lodash2.default.filter(res.data, vm.model.name + '.active');
	    });
	
	    $scope.$watch('vm.viewType', function (newValue) {
	      console.log("View type cambiato:", newValue);
	      if (newValue == 'list') {
	        vm.dots = 500;
	      } else {
	        vm.dots = 200;
	      }
	    });
	  };
	};
	ListController.$inject = ["ModelFactory", "$stateParams", "Resource", "$scope"];
	
	exports.default = ListController;

/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(568);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(349)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./list.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./list.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(348)();
	// imports
	
	
	// module
	exports.push([module.id, ".resource-list .features{font-size:10px;text-align:center}.resource-list .features .fa{font-size:16px;display:block}.resource-list .last-modify{font-size:11px;text-align:right}", ""]);
	
	// exports


/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(368);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(370);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _detail = __webpack_require__(570);
	
	var _detail2 = _interopRequireDefault(_detail);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var detailModule = _angular2.default.module('detail', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('dashboard.detail', {
	    url: '/detail/:modelName/:id',
	    component: 'detail',
	    params: {
	      id: null,
	      modelType: null,
	      modelName: null
	    }
	  });
	}]).component('detail', _detail2.default).name;
	
	exports.default = detailModule;

/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _detail = __webpack_require__(571);
	
	var _detail2 = _interopRequireDefault(_detail);
	
	var _detail3 = __webpack_require__(572);
	
	var _detail4 = _interopRequireDefault(_detail3);
	
	__webpack_require__(573);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var detailComponent = {
	  bindings: {
	    item: "<",
	    modelName: "<"
	  },
	  template: _detail2.default,
	  controller: _detail4.default,
	  controllerAs: "vm"
	};
	
	exports.default = detailComponent;

/***/ }),
/* 571 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"detail\">\n  <div class=\"section section-tabs\">\n    <div class=\"row\">\n      <div class=\"col-sm-6\">\n\n        <h1 ng-show=\"!vm.isNew\">{{vm.modelEnum | translate}}</h1>\n        <h1 ng-show=\"vm.isNew\">{{vm.modelEnum | translate}}</h1>\n\n      </div>\n      <div class=\"col-sm-6 text-right\">\n        <button class=\"btn btn-link btn-primary\"\n                ng-class=\"{'button-active': vm.language == 'IT'}\"\n                ng-click=\"vm.setLanguage('IT')\">\n          IT\n        </button>\n        <button class=\"btn btn-link btn-primary\"\n                ng-class=\"{'button-active': vm.language == 'EN'}\"\n                ng-click=\"vm.setLanguage('EN')\">\n          EN\n        </button>\n        <button class=\"btn btn-link btn-primary\"\n                ng-class=\"{'button-active': vm.language == 'FR'}\"\n                ng-click=\"vm.setLanguage('FR')\">\n          FR\n        </button>\n        <button class=\"btn btn-link btn-primary\"\n                ng-class=\"{'button-active': vm.language == 'DE'}\"\n                ng-click=\"vm.setLanguage('DE')\">\n          DE\n        </button>\n      </div>\n    </div>\n\n    <div class=\"row\">\n      <div class=\"col-sm-12\">\n        <div class=\"card\">\n          <!--justify-content-center-->\n          <ul class=\"nav nav-tabs nav-tabs-neutral\"\n              role=\"tablist\"\n              data-background-color=\"orange\">\n            <li class=\"nav-item\">\n              <a class=\"nav-link\"\n                 href=\"\"\n                 ng-click=\"vm.section = 'description'\"\n                 ng-class=\"{active: vm.section == 'description'}\">Descrizione</a>\n            </li>\n            <li class=\"nav-item\">\n              <a class=\"nav-link\"\n                 ng-show=\"!vm.isNew\"\n                 href=\"\"\n                 ng-click=\"vm.section = 'gallery'\"\n                 ng-class=\"{active: vm.section == 'gallery'}\">Galleria immagini</a>\n            </li>\n            <li class=\"nav-item\">\n              <a class=\"nav-link\"\n                 ng-show=\"!vm.isNew\"\n                 href=\"\"\n                 ng-click=\"vm.section = 'map'\"\n                 ng-class=\"{active: vm.section == 'map'}\">Mappa</a>\n            </li>\n          </ul>\n          <div class=\"card-body\">\n            <div class=\"tab-content\">\n              <!--<div ui-view></div>-->\n              <description ng-if=\"vm.section == 'description'\"\n                           item=\"vm.item\"\n                           language=\"vm.language\"\n                           model=\"vm.modelName\"></description>\n              <gallery ng-if=\"vm.section == 'gallery'\"\n                       ng-show=\"!vm.isNew\"\n                       item=\"vm.item\"\n                       language=\"vm.language\"\n                       reinit=\"vm.init()\"\n                       get-detail=\"vm.getDetail\"></gallery>\n              <map ng-if=\"vm.section == 'map'\"\n                   ng-show=\"!vm.isNew\"\n                   item=\"vm.item\"\n                   language=\"vm.language\"\n                   model=\"vm.modelName\"></map>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(498);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _lodash = __webpack_require__(499);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DetailController = function DetailController($stateParams, LanguageFactory, ModelFactory, Resource) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, DetailController);
	    var vm = this;
	    vm.language = 'IT';
	    vm.setLanguage = setLanguage;
	    vm.item = {};
	    vm.section = 'description';
	    vm.model = '';
	    vm.isNew = true;
	    vm.$onInit = init;
	    vm.init = init;
	    vm.getDetail = getDetail;
	    vm.createNew = createNew;
	
	    function init() {
	        if (!_lodash2.default.has($stateParams, 'id') || !_lodash2.default.has($stateParams, 'modelType')) {
	            throw 'incomplete parameters for detail.controller.js';
	        }
	
	        vm.modelName = $stateParams.modelName;
	        vm.modelEnum = vm.modelName.toUpperCase();
	
	        if ($stateParams.id === "new") {
	            vm.isNew = true;
	            createNew(vm.modelName);
	        } else {
	            vm.isNew = false;
	            vm.getDetail($stateParams.id, vm.modelName);
	        }
	    }
	
	    function createNew(modelName) {
	        var modelStructure = _lodash2.default.result(ModelFactory, 'get' + _lodash2.default.upperFirst(vm.modelName) + 'Structure');
	        vm.item = {};
	        vm.item[modelName] = {};
	        vm.item[modelName + 'StringsList'] = [];
	        var lang = {};
	
	        // Ricostruisci l'oggetto secondo il modello sul backend, incluse
	        // le strings list.
	        _lodash2.default.each(modelStructure.model, function (value, key) {
	            // proprietà di strings list
	            if (value.prefix === 'lang') {
	                lang[key] = "";
	            }
	            // proprietà diretta della risorsa
	            else if (value.prefix.indexOf("vm.") > -1) {
	                    vm.item[modelName][key] = "";
	                }
	        });
	
	        // Aggiungi tutte le lingue nella strings list
	        _lodash2.default.each(LanguageFactory.getAvailableLanguageKeys(), function (l) {
	            var langClone = _lodash2.default.clone(lang);
	            langClone.language = l;
	            vm.item[modelName + 'StringsList'].push(langClone);
	        });
	    }
	
	    function getDetail(id, modelName) {
	        Resource.get(modelName, id).then(function (res) {
	            var langs = [];
	            var defaultLanguage = _lodash2.default.find(_lodash2.default.get(res.data, modelName + 'StringsList'), { language: LanguageFactory.getDefaultLanguage() });
	
	            console.log("Default language:", defaultLanguage);
	
	            // Aggiungi le lingue mancanti clonando l'italiano,
	            // assumendo l'italiano come sempre presente per costruzione.
	            _lodash2.default.each(LanguageFactory.getAvailableLanguageKeys(), function (lang) {
	                var elem = _lodash2.default.find(_lodash2.default.get(res.data, modelName + 'StringsList'), { language: lang });
	                var newElem = {};
	                if (!elem && lang !== LanguageFactory.getDefaultLanguage()) {
	                    newElem = _lodash2.default.clone(defaultLanguage);
	                    newElem.language = lang; //override della lingua di default
	                    delete newElem.id; //non salvare l'id!
	                    langs.push(newElem);
	                } else {
	                    langs.push(elem);
	                }
	            });
	            res.data[modelName + 'StringsList'] = langs; //result: res.data.floraStringsList = langs
	            console.log('Resource details:', res.data);
	            vm.item = res.data;
	        });
	    }
	
	    function setLanguage(language) {
	        vm.language = language;
	        // $stateParams.language = vm.language;
	    }
	};
	DetailController.$inject = ["$stateParams", "LanguageFactory", "ModelFactory", "Resource"];
	
	exports.default = DetailController;

/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(574);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(349)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./detail.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./detail.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(348)();
	// imports
	
	
	// module
	exports.push([module.id, ".detail .map{height:500px;margin-bottom:20px}.detail .gallery .img{margin-bottom:15px}", ""]);
	
	// exports


/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(368);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(370);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _description = __webpack_require__(576);
	
	var _description2 = _interopRequireDefault(_description);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var descriptionModule = _angular2.default.module('description', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('dashboard.detail.description', {
	    url: '/description',
	    component: 'description'
	    // params: {
	    //   item: null,
	    //   language: "IT"
	    // }
	  });
	}]).component('description', _description2.default).name;
	
	exports.default = descriptionModule;

/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _description = __webpack_require__(577);
	
	var _description2 = _interopRequireDefault(_description);
	
	var _description3 = __webpack_require__(578);
	
	var _description4 = _interopRequireDefault(_description3);
	
	__webpack_require__(579);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var descriptionComponent = {
	  bindings: {
	    item: "=",
	    language: "<",
	    model: "<",
	    modelName: "<"
	  },
	  template: _description2.default,
	  controller: _description4.default,
	  controllerAs: "vm"
	};
	
	exports.default = descriptionComponent;

/***/ }),
/* 577 */
/***/ (function(module, exports) {

	module.exports = "<form name=\"vm.form[lang.language]\"\r\n      novalidate\r\n      ng-class=\"{ 'submitted': vm.formSubmitted }\"\r\n      ng-repeat=\"lang in $eval('vm.item.'+vm.modelName+'StringsList')\"\r\n      ng-if=\"vm.language == lang.language\">\r\n\r\n\r\n  <div class=\"row form-group\"\r\n       ng-repeat=\"(modelStringField, additionalInfo) in vm.modelStructure.model\">\r\n    <div class=\"col-sm-2 text-right\">\r\n      <label>{{additionalInfo.title}}</label>\r\n    </div>\r\n    <div class=\"col-sm-10\">\r\n      <div summernote\r\n           lang=\"it-IT\"\r\n           config=\"vm.summernoteOptions\"\r\n           dynamic-model=\"additionalInfo.prefix+'.'+modelStringField\"\r\n           ng-if=\"additionalInfo.type === 'editor'\">\r\n      </div>\r\n      <!--on-blur=\"vm.changeDescription(lang)\"-->\r\n      <!--ng-model=\"vm.htmlDescription\"-->\r\n      <!--dynamic-model=\"additionalInfo.prefix+'.'+modelStringField\"\r\n      ng-model-options=\"{ getterSetter: true , updateOn: 'change' }\"\r\n      ng-required=\"additionalInfo.required\"-->\r\n      <input type=\"text\"\r\n             class=\"form-control\"\r\n             dynamic-model=\"additionalInfo.prefix+'.'+modelStringField\"\r\n             ng-model-options=\"{ getterSetter: true , updateOn: 'change' }\"\r\n             ng-required=\"additionalInfo.required\"\r\n             ng-if=\"additionalInfo.type === 'input'\">\r\n      <textarea class=\"form-control\"\r\n                rows=\"{{additionalInfo.row}}\"\r\n                dynamic-model=\"additionalInfo.prefix+'.'+modelStringField\"\r\n                ng-model-options=\"{ getterSetter: true , updateOn: 'change' }\"\r\n                ng-required=\"additionalInfo.required\"\r\n                ng-if=\"additionalInfo.type === 'textarea'\">\r\n      </textarea>\r\n      <textarea class=\"form-control\"\r\n                rows=\"{{additionalInfo.row}}\"\r\n                dynamic-model=\"additionalInfo.prefix+'.'+modelStringField\"\r\n                ng-model-options=\"{ getterSetter: true , updateOn: 'change' }\"\r\n                ng-required=\"additionalInfo.required\"\r\n                ng-if=\"additionalInfo.type === 'numeric-array'\"\r\n                is-numeric-array=\"additionalInfo.type === 'numeric-array'\">\r\n      </textarea>\r\n      <select class=\"form-control\"\r\n              dynamic-model=\"additionalInfo.prefix+'.'+modelStringField\"\r\n              ng-model-options=\"{ getterSetter: true , updateOn: 'change' }\"\r\n              ng-if=\"additionalInfo.type === 'select'\"\r\n              ng-required=\"additionalInfo.required\">\r\n        <option ng-repeat=\"type in additionalInfo.enum\"\r\n                ng-selected=\"$index === 0\"\r\n                ng-value=\"type\">\r\n          {{type | snakeToSpace}}\r\n\r\n        </option>\r\n      </select>\r\n    </div>\r\n  </div>\r\n\r\n  <div class=\"text-right\">\r\n    <button class=\"btn btn-secondary btn-round\"\r\n            ng-click=\"vm.remove()\">\r\n      Cancella risorsa\r\n    </button>\r\n\r\n    <button class=\"btn btn-primary btn-round\"\r\n            ng-click=\"vm.save(lang)\">\r\n      Salva modifiche\r\n    </button>\r\n  </div>\r\n</form>\r\n"

/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(498);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _lodash = __webpack_require__(499);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DescriptionController = function DescriptionController(growl, ModelFactory, Resource, $state, $uibModal, Util) {
	  'ngInject';
	
	  (0, _classCallCheck3.default)(this, DescriptionController);
	  var vm = this;
	  vm.form = {};
	  vm.summernoteOptions = Util.getSummernoteOptions();
	  vm.htmlDescription = "";
	  vm.save = save;
	  vm.$onInit = init;
	  vm.formSubmitted = false;
	  vm.remove = remove;
	
	  function init() {
	    vm.modelName = vm.model; // preso dal parent
	    vm.modelStructure = _lodash2.default.result(ModelFactory, 'get' + _lodash2.default.upperFirst(vm.modelName) + 'Structure');
	
	    console.log("Lang:", vm.language);
	    /*Invoke e.g ModelFactory.getNatureStructure()*/
	  }
	
	  function save(itemStrings) {
	
	    if (vm.form[vm.language].$invalid) {
	      vm.formSubmitted = true;
	      angular.forEach(vm.form[vm.language].$error, function (value, key) {
	        if (key === 'numeric-array') {
	          growl.error('Il geojeson inserito non è valido');
	        } else if (key === 'required') {
	          growl.error('Compilare tutti i campi obbligatori');
	        }
	      });
	      return;
	    }
	
	    var itemToSave = {};
	    itemToSave[vm.modelName] = _lodash2.default.get(vm.item, vm.modelName);
	
	    // Se non c'è l'id, la risorsa è nuova da inserire
	    if (_lodash2.default.isNil(itemToSave[vm.modelName].id)) {
	
	      itemToSave[vm.modelName].active = true;
	      itemToSave[vm.modelName + 'StringsList'] = _lodash2.default.get(vm.item, vm.modelName + 'StringsList');
	      itemToSave.geoPoints = [];
	      /* Example: Resource.post('flora', vm.item.flora) */
	      Resource.post(vm.modelName, itemToSave).then(function (res) {
	        console.log('Risorsa salvata!', res);
	        vm.item = res.data;
	        if (vm.modelName === 'itinerary') {
	          var model = _lodash2.default.get(itemToSave, vm.model);
	          var geojson = JSON.parse(model.geojson);
	          saveGeoPoints(geojson[0]).then(function (e) {
	            growl.success('Risorsa creata con successo!');
	            $state.go('dashboard.detail.description', {
	              id: res.data[vm.modelName].id,
	              modelName: vm.modelName
	            });
	          });
	        } else {
	          growl.success('Risorsa creata con successo!');
	          $state.go('dashboard.detail.description', {
	            id: res.data[vm.modelName].id,
	            modelName: vm.modelName
	          });
	        }
	      }, function (err) {
	        growl.error('Errore nella creazione della risorsa');
	      });
	    } else {
	      /* Example: Resource.put('flora', vm.item.flora) */
	      itemToSave.geoPoints = _lodash2.default.get(vm.item, 'geoPoints');
	      Resource.put(vm.modelName, itemToSave).then(function (res) {
	        console.log('Risorsa salvata!', res);
	
	        Resource.putStrings(vm.modelName, itemStrings).then(function (res) {
	          console.log('Stringhe modificate per', itemStrings, 'risposta:', res);
	          growl.success('Modifica salvata con successo');
	
	          if (vm.modelName === 'itinerary') {
	            var model = _lodash2.default.get(itemToSave, vm.model);
	            var geojson = JSON.parse(model.geojson);
	            saveGeoPoints(geojson[0]);
	          }
	        });
	      });
	    }
	  }
	
	  /**
	   * Save geo points
	   */
	  function saveGeoPoints(latLngArray) {
	
	    var itemToSave = {};
	    itemToSave[vm.model] = _lodash2.default.get(vm.item, vm.model);
	    itemToSave.geoPoints = [];
	    var geoPoint = {
	      latitude: latLngArray[1],
	      longitude: latLngArray[0]
	    };
	    itemToSave.geoPoints.push(geoPoint);
	    return Resource.putGeoPoints(vm.model, itemToSave).then(function (res) {}, function (err) {
	      growl.error('Errore nel salvataggio delle coordinate geografiche');
	    });
	  }
	
	  function remove() {
	    $uibModal.open({
	      component: 'confirmDialog',
	      windowClass: 'modal-mini modal-primary',
	      resolve: {
	        message: function message() {
	          return 'Confermi di voler cancellare questa risorsa?';
	        }
	      }
	    }).result.then(function () {
	      Resource.remove(vm.modelName, _lodash2.default.get(vm.item, vm.modelName + '.id')).then(function (res) {
	        growl.success('Risorsa cancellata con successo!');
	
	        $state.go('dashboard.list', {
	          modelEnum: vm.modelName.toUpperCase()
	        });
	      });
	    });
	  }
	};
	DescriptionController.$inject = ["growl", "ModelFactory", "Resource", "$state", "$uibModal", "Util"];
	
	exports.default = DescriptionController;

/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(580);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(349)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./description.scss", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./description.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(348)();
	// imports
	
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(368);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(370);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _map = __webpack_require__(582);
	
	var _map2 = _interopRequireDefault(_map);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapModule = _angular2.default.module('map', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('dashboard.detail.map', {
	    url: '/map',
	    component: 'map',
	    params: {
	      item: null
	    }
	  });
	}]).component('map', _map2.default).name;
	
	exports.default = mapModule;

/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _map = __webpack_require__(583);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _map3 = __webpack_require__(584);
	
	var _map4 = _interopRequireDefault(_map3);
	
	__webpack_require__(585);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapComponent = {
	  bindings: {
	    item: "=",
	    language: "<",
	    model: "<"
	  },
	  template: _map2.default,
	  controller: _map4.default,
	  controllerAs: "vm"
	};
	
	exports.default = mapComponent;

/***/ }),
/* 583 */
/***/ (function(module, exports) {

	module.exports = "<p>\n    Clicca sulla mappa per aggiungere nuovi punti di questa risorsa. <br>\n    Per cancellare i punti esistenti, clicca sui singoli marker da eliminare.\n</p>\n<div class=\"map\">\n    <div id=\"map\"\n         class=\"map\">\n    </div>\n</div>\n<div ng-if=\"vm.model!=='itinerary'\">\n    <h4 style=\"display: inline-block\">Coordinate geografiche</h4>\n    <button class=\"btn btn-round btn-primary\"\n            ng-click=\"vm.addManualPoint()\">Aggiungi\n    </button>\n\n    <div class=\"row\"\n         ng-repeat=\"point in vm.item.geoPoints\"\n         style=\"margin-bottom: 10px\">\n        <div class=\"col-md-3\">\n            <label>Latitudine</label>\n            <input type=\"number\"\n                   class=\"form-control\"\n                   ng-model=\"point.latitude\">\n        </div>\n        <div class=\"col-md-3\">\n            <label>Longitudine</label>\n            <input type=\"number\"\n                   class=\"form-control\"\n                   ng-model=\"point.longitude\">\n        </div>\n        <div class=\"col-sm-3\">\n            <label>&nbsp</label>\n            <div>\n                <button class=\"btn btn-sm btn-primary btn-round\"\n                        ng-if=\"!!point.latitude && !!point.longitude && !point.id && !point.added\"\n                        ng-click=\"vm.saveSinglePoint(point)\">\n                    salva\n                </button>\n\n                <button class=\"btn btn-sm btn-secondary btn-round\"\n                        ng-click=\"vm.removeManualPoint($index)\">\n                    rimuovi\n                </button>\n            </div>\n        </div>\n    </div>\n    <br>\n    <br>\n    <br>\n</div>\n<div class=\"text-right\"\n     ng-if=\"vm.model!=='itinerary'\">\n    <button class=\"btn btn-secondary btn-round\"\n            ng-click=\"vm.removeAll()\">\n        Cancella tutti i punti\n    </button>\n\n    <button class=\"btn btn-primary btn-round\"\n            ng-click=\"vm.save()\">\n        Salva modifiche\n    </button>\n</div>\n"

/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(498);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapController = function MapController(Resource, growl, $http, GeojsonBuilder, $scope) {
	  'ngInject';
	
	  (0, _classCallCheck3.default)(this, MapController);
	  var vm = this;
	  vm.map;
	  vm.markers = [];
	  vm.$onInit = init;
	  vm.removeAll = removeAll;
	  vm.onMapClick = onMapClick;
	  vm.save = save;
	  vm.addToMap = addToMap;
	  vm.addProtectedArea = addProtectedArea;
	  vm.addManualPoint = addManualPoint;
	  vm.removeManualPoint = removeManualPoint;
	  vm.saveSinglePoint = saveSinglePoint;
	
	  /**
	   *
	   * @param e Leaflet click event
	   */
	  function onMapClick(e) {
	    addToMap(e.latlng.lat, e.latlng.lng);
	  }
	
	  function addManualPoint(latitude, longitude) {
	    if (vm.item.geoPoints.length === vm.markers.length - 1 || vm.item.geoPoints.length === vm.markers.length) {
	      vm.item.geoPoints.push({ added: false });
	    }
	  }
	
	  function removeManualPoint(index) {
	    var geoPoint = vm.item.geoPoints[index];
	    var removedMarkers = _.remove(vm.markers, function (marker) {
	      return marker.marker._latlng.lng == geoPoint.longitude && marker.marker._latlng.lat == geoPoint.latitude;
	    });
	    if (!_.isEmpty(removedMarkers)) {
	      removedMarkers.filter(function (marker) {
	        vm.map.removeLayer(marker.marker);
	      });
	    }
	    vm.item.geoPoints.splice(index, 1);
	  }
	
	  function saveSinglePoint(point) {
	    point.added = true;
	    addToMap(point.latitude, point.longitude);
	  }
	
	  /**
	   *
	   * @param latitude
	   * @param longitude
	   */
	  function addToMap(latitude, longitude) {
	    if (_.find(vm.markers, function (el) {
	      return el.marker._latlng.lat === latitude && el.marker._latlng.lng === longitude;
	    })) {
	      // console.log("marker già esistente", latitude, longitude)
	      return false;
	    }
	
	    var marker = L.marker([latitude, longitude], {
	      icon: L.icon({
	        iconUrl: 'assets/img/pin.png',
	        iconSize: [29.5, 40],
	        iconAnchor: [15, 40]
	      })
	    }).addTo(vm.map);
	
	    marker.index = vm.markers.length;
	    vm.markers.push({ index: vm.markers.length, marker: marker });
	    marker.on('click', function (e) {
	      vm.map.removeLayer(e.target);
	      _.remove(vm.markers, function (marker) {
	        return marker.index === e.target.index;
	      });
	      _.remove(vm.item.geoPoints, function (geoPoint) {
	        return geoPoint.latitude == e.latlng.lat && geoPoint.longitude == e.latlng.lng;
	      });
	      $scope.$apply();
	    });
	  }
	
	  /**
	   * Remove geo points from map
	   */
	  function removeAll() {
	    vm.markers.filter(function (marker) {
	      vm.map.removeLayer(marker.marker);
	    });
	    vm.markers = [];
	    vm.item.geoPoints = [];
	    $scope.$apply();
	  }
	
	  /**
	   * Save geo points
	   */
	  function save() {
	    var itemToSave = {};
	    itemToSave[vm.model] = _.get(vm.item, vm.model);
	    itemToSave.geoPoints = [];
	    vm.markers.filter(function (marker) {
	      var geoPoint = {
	        latitude: marker.marker._latlng.lat,
	        longitude: marker.marker._latlng.lng
	      };
	      itemToSave.geoPoints.push(geoPoint);
	    });
	    Resource.putGeoPoints(vm.model, itemToSave).then(function (res) {
	      growl.success('Coordinate geografiche salvate con successo');
	    }, function (err) {
	      growl.error('Errore nel salvataggio delle coordinate geografiche');
	    });
	  }
	
	  function addProtectedArea() {
	    $http.get('/assets/json/area-protetta.geojson').then(function (res) {
	      var geojson = L.geoJson(res.data, {
	        style: {
	          fillColor: 'gray',
	          weight: 1,
	          opacity: 1,
	          color: 'blue',
	          dashArray: '3,2,3',
	          fillOpacity: 0.25
	        }
	      }).addTo(vm.map);
	    });
	  }
	
	  function init() {
	
	    console.log(_.get(vm.item, vm.model));
	    console.log(vm.model);
	    vm.map = L.map('map').setView([43.992642, 7.766251], 11);
	    L.tileLayer('https://api.tiles.mapbox.com/v4/{id}/{z}/{x}/{y}.png?access_token={accessToken}', {
	      attribution: '<a href="http://openstreetmap.org">OpenStreetMap</a> | <a href="http://mapbox.com">Mapbox</a>',
	      maxZoom: 21,
	      id: 'mapbox.streets',
	      accessToken: 'pk.eyJ1IjoibWFpbHZpcm9vcyIsImEiOiJjajlkNnJ6bnQxeDFwMnFveW9hcHJ6NGI4In0.81GT3m2HWbB2efieELsj8Q',
	      zoomAnimation: true
	    }).addTo(vm.map);
	    vm.addProtectedArea();
	    Resource.get(vm.model, _.get(vm.item, vm.model + '.id')).then(function (res) {
	      vm.item.geoPoints = res.data.geoPoints;
	      res.data.geoPoints.filter(function (geoPoint) {
	        addToMap(geoPoint.latitude, geoPoint.longitude);
	      });
	    });
	    var model = _.get(vm.item, vm.model);
	    if (_.has(model, 'geojson')) {
	      var geojson = GeojsonBuilder.getGeojson(JSON.parse(model.geojson));
	      console.log(geojson);
	      var jsonLayer = L.geoJSON(geojson, {
	        style: {
	          fillColor: 'green',
	          weight: 4,
	          opacity: 1,
	          color: 'blue',
	          dashArray: '3',
	          fillOpacity: 0.8
	        }
	      });
	      jsonLayer.addTo(vm.map);
	      vm.map.fitBounds(jsonLayer.getBounds());
	    }
	    if (vm.model !== 'itinerary') {
	      vm.map.on('click', vm.onMapClick);
	    }
	  }
	};
	MapController.$inject = ["Resource", "growl", "$http", "GeojsonBuilder", "$scope"];
	
	exports.default = MapController;

/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(586);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(349)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./map.scss", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./map.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(348)();
	// imports
	
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(368);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(370);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _gallery = __webpack_require__(588);
	
	var _gallery2 = _interopRequireDefault(_gallery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var galleryModule = _angular2.default.module('gallery', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('dashboard.detail.gallery', {
	    url: '/gallery',
	    component: 'gallery',
	    params: {
	      item: null
	    }
	  });
	}]).component('gallery', _gallery2.default).name;
	
	exports.default = galleryModule;

/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _gallery = __webpack_require__(589);
	
	var _gallery2 = _interopRequireDefault(_gallery);
	
	var _gallery3 = __webpack_require__(590);
	
	var _gallery4 = _interopRequireDefault(_gallery3);
	
	__webpack_require__(591);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var galleryComponent = {
	  bindings: {
	    item: "=",
	    language: "<",
	    reinit: "&"
	  },
	  template: _gallery2.default,
	  controller: _gallery4.default,
	  controllerAs: "vm"
	};
	
	exports.default = galleryComponent;

/***/ }),
/* 589 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"gallery\">\n  <div class=\"row\">\n    <div class=\"col-sm-3\"\n         ng-repeat=\"image in vm.item.images\">\n      <a href=\"\"\n         ng-click=\"vm.openImageDetail(image.url, image.id)\">\n        <img class=\"img img-responsive\"\n             ng-src=\"{{ image.url }}\">\n      </a>\n    </div>\n  </div>\n  <div ngf-drop=\"vm.uploadFile($file)\"\n       ngf-select=\"vm.uploadFile($file)\"\n       class=\"drop-box Drag-Drop\"\n       ngf-drag-over-class=\"'dragover'\"\n       ngf-multiple=\"false\"\n       ngf-pattern=\"'image/*'\"\n       ngf-resize=\"{width: 1920, height: 1080, quality: 1.0, type: 'image/jpeg',\n            centerCrop: true, pattern='.jpg', restoreExif: false}\">\n\n    <div class=\"row\">\n      <div class=\"col-sm-3\">\n        <i class=\"fa fa-picture-o\"></i>\n      </div>\n      <div class=\"col-sm-9\">\n        <strong>Clicca</strong> o <strong>trascina</strong> qui una nuova immagine per\n        caricarla\n      </div>\n    </div>\n  </div>\n  <div ngf-no-file-drop>Questo browser non supporta il trascinamento dei file. Clicca per caricare\n    un'immagine\n  </div>\n  <div class=\"Percentage-indicator\"\n       ng-show=\"vm.percent > 0 && vm.percent < 100\">\n    <percent-circle percent=\"vm.percent\"></percent-circle>\n  </div>\n</div>\n"

/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(498);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GalleryController = function GalleryController(Image, Upload, SERVER_URL, ModelFactory, growl) {
	  'ngInject';
	
	  (0, _classCallCheck3.default)(this, GalleryController);
	  var vm = this;
	  var modalInstance = void 0;
	  // vm.openImageDetail = Image.openDetail;
	  vm.openImageDetail = function (imageSource, imageId) {
	    modalInstance = Image.openDetail(imageSource, imageId, vm.reinit);
	  };
	
	  vm.test = function () {
	    console.log(ModelFactory.getModel(vm.item));
	  };
	
	  vm.uploadFile = function (file) {
	    if (file) {
	      Upload.upload({
	        url: SERVER_URL + '/images-with-multipart',
	        data: {
	          file: file,
	          fileName: file.name,
	          modelName: ModelFactory.getModel(vm.item).enum,
	          id: _.get(vm.item, ModelFactory.getModel(vm.item).name + '.id')
	        }
	      }).then(function suc(response) {
	        console.log('Success %o', response);
	        growl.success('Immagine caricata con successo!');
	        //self.model.image = response.data.result[0].name;
	        refreshDetail();
	      }, function err(response) {
	        console.log('Error: %o', response);
	        alert('Couldn\'t upload file');
	      }, function prg(e) {
	        var progressPercentage = parseInt(100.0 * e.loaded / e.total);
	        vm.percent = progressPercentage;
	        //console.log(e);
	      });
	    }
	  };
	
	  function deleteCallback() {
	    modalInstance.result.close();
	    refreshDetail();
	  }
	
	  function refreshDetail() {
	    if (_.isFunction(vm.reinit)) {
	      vm.reinit();
	    }
	  }
	};
	GalleryController.$inject = ["Image", "Upload", "SERVER_URL", "ModelFactory", "growl"];
	
	exports.default = GalleryController;

/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(592);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(349)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./gallery.scss", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./gallery.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(348)();
	// imports
	
	
	// module
	exports.push([module.id, ".gallery .Drag-Drop{padding:25px;background-color:#eee;margin:0 0 35px;width:100%}.gallery .Drag-Drop .fa{font-size:50px;color:grey}", ""]);
	
	// exports


/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(368);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(370);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _comments = __webpack_require__(594);
	
	var _comments2 = _interopRequireDefault(_comments);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var commentsModule = _angular2.default.module('comments', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('dashboard.comments', {
	    url: '/comments',
	    component: 'comments'
	  });
	}]).component('comments', _comments2.default).name;
	
	exports.default = commentsModule;

/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _comments = __webpack_require__(595);
	
	var _comments2 = _interopRequireDefault(_comments);
	
	var _comments3 = __webpack_require__(596);
	
	var _comments4 = _interopRequireDefault(_comments3);
	
	__webpack_require__(597);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var commentsComponent = {
	  bindings: {},
	  template: _comments2.default,
	  controller: _comments4.default,
	  controllerAs: "vm"
	};
	
	exports.default = commentsComponent;

/***/ }),
/* 595 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"comments\">\n  <div class=\"row\">\n    <div class=\"col-sm-6\">\n      <h1>Segnalazioni e commenti</h1>\n      <h6 class=\"text-primary\">trovati <strong>{{ vm.comments.length }}</strong> elementi</h6>\n    </div>\n    <div class=\"col-sm-6 text-right\">\n      <div class=\"row\">\n        <div class=\"col-sm-6\">\n        </div>\n        <div class=\"col-sm-6\">\n          <select class=\"form-control\" ng-model=\"vm.reportFilter\" ng-change=\"vm.changeReportFilter()\">\n            <option value=\"all\">Tutti</option>\n            <option value=\"\">Solo segnalazioni</option>\n            <option value=\"nature\">Commenti natura</option>\n            <option value=\"culture\">Commenti cultura</option>\n            <option value=\"typicalProduct\">Commenti prodotti tipici</option>\n            <option value=\"outdoor\">Commenti outdoor</option>\n            <option value=\"service\">Commenti servizi</option>\n            <option value=\"itinerary\">Commenti itinerari</option>\n          </select>\n        </div>\n      </div>\n    </div>\n  </div>\n\n  <div class=\"comments\">\n    <div class=\"row\"\n         ng-repeat=\"comment in vm.comments\" ng-class='{\"report\" : comment.modelEnum == \"undefined\"}'>\n      <div class=\"col-sm-12 col-md-12 col-lg-12 col-xl-9\">\n        <div class=\"comment\">\n          <div class=\"row\">\n            <div class=\"col-lg-1 col-md-1 col-sm-12\">\n              <img src=\"/assets/img/smartphone-avatar.jpg\"\n                   class=\"rounded-circle img-raised\">\n            </div>\n            <div class=\"col-lg-8 col-md-8 col-sm-12\">\n              <h6><i class=\"now-ui-icons users_single-02\"></i>\n                <small>{{ comment.user.firstName}}</small>\n                <i class=\"now-ui-icons ui-1_email-85\"></i>\n                <small>{{comment.user.email}}</small>\n                <i class=\"now-ui-icons ui-1_calendar-60\"></i>\n                <small>{{ comment.createdDate | date:'dd/MM/yyyy HH:mm' }}</small>\n              </h6>\n              <h6>{{ comment.title }}</h6>\n              <p>{{ comment.comment }}</p>\n              <div class=\"text-right\">\n                <button class=\"btn btn-link btn-lg btn-primary\"\n                        ng-click=\"vm.markAsRead(comment, $index)\"\n                        ng-if=\"comment.reportStatus !== 'READ'\">\n                  <i class=\"now-ui-icons ui-1_check\"></i> Segna come letto\n                </button>\n                <button class=\"btn btn-link btn-lg btn-primary\"\n                        ng-click=\"vm.markAsUnread(comment, $index)\"\n                        ng-if=\"comment.reportStatus === 'READ'\">\n                  <i class=\"now-ui-icons ui-1_simple-remove\"></i> Segna come non letto\n                </button>\n              </div>\n            </div>\n            <div class=\"col-lg-3 col-md-3 col-sm-12\">\n              <button class=\"btn btn-round btn-secondary btn-sm\"\n                      ng-if=\"comment.modelEnum !== 'all' && comment.modelEnum !== 'undefined'\"\n                      ng-click=\"vm.goToResource(comment)\">\n                <i class=\"now-ui-icons files_paper\"></i> Scheda risorsa\n              </button>\n              <button class=\"btn btn-round btn-primary btn-sm\"\n                      ng-click=\"vm.addNote(comment, $index)\">\n                <i class=\"fa fa-plus\"></i> Nota interna\n              </button>\n              <button class=\"btn btn-round btn-primary btn-sm\"\n                      ng-if=\"comment.images.length > 0\"\n                      ng-click=\"vm.viewImages(comment, $index)\">\n                <i class=\"fa fa-file-o\"></i> Immagini allegate\n              </button>\n              <button class=\"btn btn-round btn-primary btn-sm\"\n                      ng-if=\"comment.latitude !== null && comment.longitude !== null\"\n                      ng-click=\"vm.viewReportMap(comment, $index)\">\n                <i class=\"fa fa-map-marker\"></i> Mappa segnalazione\n              </button>\n            </div>\n          </div>\n\n          <div class=\"comment-properties\">\n            <strong ng-show=\"comment.adminComments.length > 0\"\n                    class=\"clickable\"\n                    ng-click=\"vm.showNewNotes[$index] = !vm.showNewNotes[$index]\">\n              <i class=\"now-ui-icons ui-2_chat-round\"></i> {{ comment.adminComments.length }}\n              <span ng-show=\"comment.adminComments.length === 1\">nota</span><span\n              ng-show=\"comment.adminComments.length > 1\">note</span>\n            </strong>\n          </div>\n          <div class=\"admin-comments\">\n            <div class=\"comment-note\"\n                 ng-if=\"vm.showNewNotes[$index]\">\n                        <textarea class=\"form-control\"\n                                  rows=\"2\"\n                                  ng-model=\"vm.newNotes[$index]\"></textarea>\n              <button class=\"btn btn-secondary btn-sm btn-round\"\n                      ng-show=\"!!vm.newNotes[$index]\"\n                      ng-click=\"vm.saveNote(comment, $index)\">Salva nota\n              </button>\n              <button class=\"btn btn-secondary btn-sm btn-round\"\n                      ng-show=\"!vm.newNotes[$index]\"\n                      ng-click=\"vm.saveNote(comment, $index)\">Nascondi\n              </button>\n            </div>\n            <div ng-if=\"vm.showNewNotes[$index]\">\n              <div class=\"admin-comment-cloud\"\n                   ng-repeat=\"adminComment in comment.adminComments | orderBy:'-createdDate'\">\n                <div class=\"admin-comment-date\">\n                  {{ adminComment.createdDate | date:'dd/MM/yyyy HH:mm' }}\n                </div>\n                {{ adminComment.comment }}\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n\n  <!--Paginazione-->\n  <div class=\"row\">\n    <div class=\"col-sm-6 text-right\">\n      <button class=\"btn btn-round btn-primary\"\n              ng-hide=\"vm.pagination.page === 0\"\n              ng-click=\"vm.prev()\"><i class=\"fa fa-angle-left\"></i> Indietro\n      </button>\n    </div>\n    <div class=\"col-sm-6\">\n      <button class=\"btn btn-round btn-primary\"\n              ng-hide=\"vm.comments.length < vm.pagination.offset\"\n              ng-click=\"vm.next()\">\n        Avanti <i class=\"fa fa-angle-right\"></i>\n      </button>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(498);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommentsController = function CommentsController(Util, Report, growl, $state, $uibModal) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, CommentsController);
	    var vm = this;
	    vm.comments = [];
	    vm.reportFilter = "all"; // mostra commenti e segnalazioni insieme
	    vm.$onInit = start;
	    vm.addNote = addNote;
	    vm.markAsRead = markAsRead;
	    vm.markAsUnread = markAsUnread;
	    vm.saveNote = saveNote;
	    vm.goToResource = goToResource;
	    vm.next = next;
	    vm.prev = prev;
	    vm.viewImages = viewImages;
	    vm.pagination = {
	        page: 0,
	        offset: 25
	    };
	    vm.newNotes = [];
	    vm.showNewNotes = [];
	    vm.changeReportFilter = start;
	    vm.viewReportMap = viewReportMap;
	
	    function start() {
	        vm.pagination.page = 0;
	        init();
	    }
	
	    function init() {
	        vm.newNotes = [];
	        vm.showNewNotes = [];
	
	        Report.getList(vm.pagination.page, vm.pagination.offset, vm.reportFilter).then(function (res) {
	            vm.comments = res.data;
	        });
	    }
	
	    function addNote(report, reportIndex) {
	        // console.log("Add note", report);
	        vm.showNewNotes[reportIndex] = true;
	    }
	
	    function saveNote(report, reportIndex) {
	        if (!vm.newNotes[reportIndex]) {
	            vm.showNewNotes[reportIndex] = false;
	            return false;
	        }
	        var adminComment = {
	            comment: vm.newNotes[reportIndex],
	            createdDate: new Date(),
	            report: { id: report.id }
	        };
	        Report.postAdminComment(adminComment).then(function (res) {
	            init();
	            vm.newNotes[reportIndex] = "";
	            vm.showNewNotes[reportIndex] = true; // continua a mostrare i commenti
	            growl.success("Nota interna aggiunta correttamente");
	        }, function (err) {
	            growl.error("Error salvataggio nota interna");
	        });
	    }
	
	    function markAsRead(report, reportIndex) {
	        var callback = function callback() {
	            growl.success("Segnalazione segnata come letta");
	            report.reportStatus = "READ";
	        };
	        changeReportStatus(report, callback);
	    }
	
	    function markAsUnread(report, reportIndex) {
	        var callback = function callback(rep) {
	            growl.success("Segnalazione segnata come non letta");
	            rep.reportStatus = "UNREAD";
	        };
	        changeReportStatus(report, callback);
	    }
	
	    function changeReportStatus(report, callback) {
	        var reportCopy = angular.copy(report);
	        Report.put(reportCopy).then(function (res) {
	            callback(report);
	        }, function (err) {
	            growl.error("Errore cambio stato segnalazione");
	        });
	    }
	
	    function goToResource(report) {
	        $state.go("dashboard.detail.description", {
	            id: report.modelId,
	            modelType: report.modelEnum,
	            modelName: report.modelEnum
	        });
	    }
	
	    function next() {
	        if (vm.comments.length < vm.pagination.offset) {
	            return;
	        }
	        vm.pagination.page++;
	        init();
	    }
	
	    function prev() {
	        if (vm.pagination.page === 0) {
	            return;
	        }
	        vm.pagination.page--;
	        init();
	    }
	
	    function viewImages(report, reportIndex) {
	        return $uibModal.open({
	            component: 'reportImages',
	            size: 'lg',
	            resolve: {
	                images: function images() {
	                    return report.images;
	                }
	            }
	        });
	    }
	
	    function viewReportMap(_report, reportIndex) {
	        return $uibModal.open({
	            component: 'reportMap',
	            size: 'lg',
	            resolve: {
	                report: function report() {
	                    return _report;
	                }
	            }
	        });
	    }
	};
	CommentsController.$inject = ["Util", "Report", "growl", "$state", "$uibModal"];
	
	exports.default = CommentsController;

/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(598);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(349)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./comments.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./comments.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(348)();
	// imports
	
	
	// module
	exports.push([module.id, ".comments{margin-top:20px}.comments .report{background-color:#ffffe0}.comments small{margin-right:10px}.comments .comment{margin:40px 0 20px;border-bottom:1px dashed #ccc;padding-bottom:5px}.comments .comment-properties{font-size:12px;font-weight:600;margin-top:15px}.comments .admin-comments textarea.form-control{padding:5px 10px}.comments .admin-comment-date{font-size:10px;text-align:right}.comments .admin-comment-cloud{background-color:#eee;padding:4px 8px 10px;border-radius:7px;margin-bottom:4px}", ""]);
	
	// exports


/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(368);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(370);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _users = __webpack_require__(600);
	
	var _users2 = _interopRequireDefault(_users);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var usersModule = _angular2.default.module('users', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('dashboard.users', {
	    url: '/users',
	    component: 'users'
	  });
	}]).component('users', _users2.default).name;
	
	exports.default = usersModule;

/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _users = __webpack_require__(601);
	
	var _users2 = _interopRequireDefault(_users);
	
	var _users3 = __webpack_require__(602);
	
	var _users4 = _interopRequireDefault(_users3);
	
	__webpack_require__(603);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var usersComponent = {
	  bindings: {},
	  template: _users2.default,
	  controller: _users4.default,
	  controllerAs: "vm"
	};
	
	exports.default = usersComponent;

/***/ }),
/* 601 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"users\">\r\n  <h1>Utenti</h1>\r\n\r\n  <table class=\"table table-striped table-hover\">\r\n    <thead>\r\n    <tr>\r\n      <th>Nome</th>\r\n      <th>Email</th>\r\n      <th>Data iscrizione</th>\r\n      <!--<th>Azioni</th>-->\r\n    </tr>\r\n    </thead>\r\n    <tbody>\r\n    <tr ng-repeat=\"user in vm.users\" class=\"clickable\" ng-click=\"vm.openUser(user)\">\r\n      <td>{{ user.firstName }}</td>\r\n      <td>{{ user.email }}</td>\r\n      <td>{{ user.createdDate | date: 'dd-MM-yyyy HH:mm' }}</td>\r\n      <!--<td>-->\r\n        <!--&lt;!&ndash;<button class=\"btn btn-xs btn-round btn-danger\">-->\r\n          <!--disattiva-->\r\n        <!--</button>&ndash;&gt;-->\r\n      <!--</td>-->\r\n    </tr>\r\n    </tbody>\r\n  </table>\r\n  <div class=\"row\">\r\n    <div class=\"col-sm-6\">\r\n      <button class=\"btn btn-xs btn-round pagination-button\"\r\n              ng-show=\"vm.pagination.page > 0\"\r\n              ng-click=\"vm.pagination.page = vm.pagination.page - 1; vm.init();\">\r\n        <i class=\"fa fa-angle-left\"></i> Indietro\r\n      </button>\r\n    </div>\r\n    <div class=\"col-sm-6 text-right\">\r\n      <button class=\"btn btn-xs btn-round pagination-button\"\r\n              ng-show=\"vm.users.length == vm.pagination.limit\"\r\n              ng-click=\"vm.pagination.page = vm.pagination.page + 1; vm.init();\">\r\n        Avanti <i class=\"fa fa-angle-right\"></i>\r\n      </button>\r\n    </div>\r\n  </div>\r\n</div>\r\n"

/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(498);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UsersController = function UsersController(User) {
	  "ngInject";
	
	  (0, _classCallCheck3.default)(this, UsersController);
	  var vm = this;
	  vm.users = [];
	  vm.pagination = {
	    page: 0,
	    limit: 25
	  };
	  vm.init = init;
	  vm.openUser = openUser;
	  init();
	
	  function init() {
	    User.getList(vm.pagination.page, vm.pagination.limit).then(function (res) {
	      vm.users = res.data;
	    });
	  }
	
	  function openUser(user) {
	    console.log("Apri dettagli utente:", user);
	  }
	};
	UsersController.$inject = ["User"];
	
	exports.default = UsersController;

/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(604);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(349)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./users.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./users.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(348)();
	// imports
	
	
	// module
	exports.push([module.id, ".users .pagination-button{transition:all .4s}", ""]);
	
	// exports


/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(368);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(370);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _information = __webpack_require__(606);
	
	var _information2 = _interopRequireDefault(_information);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var informationModule = _angular2.default.module('information', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('dashboard.information', {
	    url: '/information',
	    component: 'information'
	  });
	}]).component('information', _information2.default).name;
	
	exports.default = informationModule;

/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _information = __webpack_require__(607);
	
	var _information2 = _interopRequireDefault(_information);
	
	var _information3 = __webpack_require__(608);
	
	var _information4 = _interopRequireDefault(_information3);
	
	__webpack_require__(609);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var informationComponent = {
	  bindings: {},
	  template: _information2.default,
	  controller: _information4.default,
	  controllerAs: "vm"
	};
	
	exports.default = informationComponent;

/***/ }),
/* 607 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"information\">\n  <h1>Informazioni</h1>\n\n  <div>\n    <button class=\"btn btn-round btn-primary\"\n            ng-click=\"vm.addItem()\">\n      Aggiungi sezione\n    </button>\n  </div>\n  <br>\n\n  <!--Lista elementi già salvati-->\n  <div class=\"card\" ng-repeat=\"info in vm.items\" ng-init=\"language = 'IT'\">\n    <div class=\"card-body\">\n      <div class=\"text-right\">\n        <button class=\"btn btn-link btn-primary\"\n                ng-class=\"{'button-active': language == 'IT'}\"\n                ng-click=\"language = 'IT'\">\n          IT\n        </button>\n        <button class=\"btn btn-link btn-primary\"\n                ng-class=\"{'button-active': language == 'EN'}\"\n                ng-click=\"language = 'EN'\">\n          EN\n        </button>\n        <button class=\"btn btn-link btn-primary\"\n                ng-class=\"{'button-active': language == 'FR'}\"\n                ng-click=\"language = 'FR'\">\n          FR\n        </button>\n        <button class=\"btn btn-link btn-primary\"\n                ng-class=\"{'button-active': language == 'DE'}\"\n                ng-click=\"language = 'DE'\">\n          DE\n        </button>\n      </div>\n      <div ng-repeat=\"lang in info.informationStringsList\"\n           ng-if=\"lang.language == language\"\n           class=\"form-group\">\n        <div class=\"row\">\n          <div class=\"col-sm-2 text-right\">\n            <label>Titolo</label>\n          </div>\n          <div class=\"col-sm-10\">\n            <input type=\"text\"\n                   class=\"form-control\"\n                   ng-model=\"lang.title\">\n          </div>\n        </div>\n        <br>\n        <div class=\"row\">\n          <div class=\"col-sm-2 text-right\">\n            <label>Descrizione</label>\n          </div>\n          <div class=\"col-sm-10\">\n            <summernote\n              ng-attr-id={{'summernote-'+$index+'-'+$parent.$index}}\n              lang=\"it-IT\"\n              config=\"vm.summernoteOptions\"\n              ng-model=\"lang.body\"\n              on-image-upload=\"vm.imageUpload(files, $parent.$index, $index)\">\n            </summernote>\n          </div>\n        </div>\n\n        <div class=\"text-right\">\n          <button class=\"btn btn-sm btn-round btn-secondary\"\n                  ng-click=\"vm.deleteItem(info.information)\">\n            Cancella sezione\n          </button>\n          <button class=\"btn btn-sm btn-round btn-primary\"\n                  ng-click=\"vm.saveItem(lang)\">\n            Salva modifiche\n          </button>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(498);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _lodash = __webpack_require__(499);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var InformationController = function InformationController(Information, Util, growl, $uibModal, Upload, SERVER_URL) {
	  "ngInject";
	
	  (0, _classCallCheck3.default)(this, InformationController);
	  var vm = this;
	  vm.items = [];
	  vm.language = "IT";
	  vm.summernoteOptions = Util.getSummernoteOptions();
	  vm.addItem = addItem;
	  vm.saveItem = saveItem;
	  vm.deleteItem = deleteItem;
	  vm.imageUpload = imageUpload;
	  init();
	
	  function init() {
	    Information.getList().then(function (res) {
	      vm.items = _lodash2.default.filter(res.data, function (o) {
	        return o.information.active === true;
	      });
	      console.log("Items", vm.items);
	    });
	  }
	
	  function addItem() {
	    $uibModal.open({
	      component: 'addNew',
	      size: 'lg'
	    }).result.then(function (closed) {
	      init();
	    });
	  }
	
	  function saveItem(itemToSave) {
	    Information.putString(itemToSave).then(function (res) {
	      vm.newItem = null;
	      growl.success("Sezione modificata con successo");
	    }, function (err) {
	      growl.error("Errore modifica sezione");
	    });
	  }
	
	  function deleteItem(itemToDelete) {
	    $uibModal.open({
	      component: 'confirmDialog',
	      windowClass: 'modal-mini modal-primary',
	      resolve: {
	        message: function message() {
	          return "Confermi di voler cancellare questa sezione?";
	        }
	      }
	    }).result.then(function () {
	      Information.deleteItem(itemToDelete).then(function (res) {
	        growl.success("Sezione cancellata con successo!");
	        init();
	      }, function (err) {
	        growl.error("Errore cancellazione sezione");
	      });
	    });
	  }
	  function imageUpload(images, informationIndex, langIndex) {
	    Upload.upload({
	      url: SERVER_URL + '/images/public-image',
	      data: {
	        file: images[0]
	      }
	    }).then(function (resp) {
	      var imgNode = $("<img>").attr('src', resp.data.url)[0];
	      var container = $('#summernote-' + langIndex + '-' + informationIndex);
	      container.summernote('insertNode', imgNode);
	      vm.items[informationIndex].faqstringsList[langIndex].body = container.summernote('code');
	      $timeout(function () {}, 2000);
	    }, function (resp) {
	      console.log('Error status: ' + resp.status);
	    }, function (evt) {});
	  }
	};
	InformationController.$inject = ["Information", "Util", "growl", "$uibModal", "Upload", "SERVER_URL"];
	
	exports.default = InformationController;

/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(610);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(349)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./information.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./information.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(348)();
	// imports
	
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(368);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(370);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _addNew = __webpack_require__(612);
	
	var _addNew2 = _interopRequireDefault(_addNew);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var addNewModule = _angular2.default.module('addNew', [_angularUiRouter2.default]).component('addNew', _addNew2.default).name;
	
	exports.default = addNewModule;

/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _addNew = __webpack_require__(613);
	
	var _addNew2 = _interopRequireDefault(_addNew);
	
	var _addNew3 = __webpack_require__(614);
	
	var _addNew4 = _interopRequireDefault(_addNew3);
	
	__webpack_require__(615);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var addNewComponent = {
	  bindings: {
	    close: '&',
	    dismiss: '&',
	    resolve: '<'
	  },
	  template: _addNew2.default,
	  controller: _addNew4.default,
	  controllerAs: "vm"
	};
	
	exports.default = addNewComponent;

/***/ }),
/* 613 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header text-center\">\r\n  <h5 class=\"modal-title\">Crea nuova sezione \"Informazioni\"</h5>\r\n</div>\r\n<div class=\"modal-body\">\r\n  <div class=\"text-right\">\r\n    <button class=\"btn btn-link btn-primary\"\r\n            ng-class=\"{'button-active': vm.language == 'IT'}\"\r\n            ng-click=\"vm.language = 'IT'\">\r\n      IT\r\n    </button>\r\n    <button class=\"btn btn-link btn-primary\"\r\n            ng-class=\"{'button-active': vm.language == 'EN'}\"\r\n            ng-click=\"vm.language = 'EN'\">\r\n      EN\r\n    </button>\r\n    <button class=\"btn btn-link btn-primary\"\r\n            ng-class=\"{'button-active': vm.language == 'FR'}\"\r\n            ng-click=\"vm.language = 'FR'\">\r\n      FR\r\n    </button>\r\n    <button class=\"btn btn-link btn-primary\"\r\n            ng-class=\"{'button-active': vm.language == 'DE'}\"\r\n            ng-click=\"vm.language = 'DE'\">\r\n      DE\r\n    </button>\r\n  </div>\r\n  <div ng-repeat=\"lang in vm.newItem.informationStringsList\"\r\n       ng-show=\"lang.language == vm.language\"\r\n       class=\"form-group\">\r\n    <div class=\"row\">\r\n      <div class=\"col-sm-2 text-right\">\r\n        <label>Titolo</label>\r\n      </div>\r\n      <div class=\"col-sm-10\">\r\n        <input type=\"text\"\r\n               class=\"form-control\"\r\n               ng-model=\"lang.title\">\r\n      </div>\r\n    </div>\r\n    <br>\r\n    <div class=\"row\">\r\n      <div class=\"col-sm-2 text-right\">\r\n        <label>Descrizione</label>\r\n      </div>\r\n      <div class=\"col-sm-10\">\r\n        <div summernote\r\n             lang=\"it-IT\"\r\n             config=\"vm.summernoteOptions\"\r\n             ng-model=\"lang.body\">\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n<div class=\"modal-footer\">\r\n  <button class=\"btn btn-primary btn-round\"\r\n          ng-click=\"vm.saveNewItem(vm.newItem)\"><span class=\"ti ti-check\"></span> Salva sezione\r\n  </button>\r\n  <button class=\"btn btn-default btn-round\"\r\n          ng-click=\"vm.dismiss()\"><span class=\"ti ti-close\"></span> Chiudi\r\n  </button>\r\n</div>\r\n"

/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(498);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _lodash = __webpack_require__(499);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AddNewController = function AddNewController(LanguageFactory, growl, Information, Util) {
	  "ngInject";
	
	  (0, _classCallCheck3.default)(this, AddNewController);
	  var vm = this;
	  vm.newItem = null;
	  vm.language = "IT";
	  vm.summernoteOptions = Util.getSummernoteOptions();
	
	  vm.saveNewItem = saveNewItem;
	
	  init();
	
	  function init() {
	    vm.newItem = {
	      information: {
	        active: true
	      },
	      informationStringsList: []
	    };
	
	    _lodash2.default.each(LanguageFactory.getAvailableLanguageKeys(), function (l) {
	      vm.newItem.informationStringsList.push({
	        title: "",
	        body: "",
	        language: l
	      });
	    });
	  }
	
	  function saveNewItem(itemToSave) {
	    Information.post(itemToSave).then(function (res) {
	      growl.success("Sezione aggiunta con successo");
	      vm.close();
	    }, function (err) {
	      growl.error("Errore salvataggio sezione");
	    });
	  }
	};
	AddNewController.$inject = ["LanguageFactory", "growl", "Information", "Util"];
	
	exports.default = AddNewController;

/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(616);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(349)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./addNew.scss", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./addNew.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(348)();
	// imports
	
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(368);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(370);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _login = __webpack_require__(618);
	
	var _login2 = _interopRequireDefault(_login);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var loginModule = _angular2.default.module('login', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('login', {
	    url: '/',
	    component: 'login'
	  });
	}]).component('login', _login2.default).name;
	
	exports.default = loginModule;

/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _login = __webpack_require__(619);
	
	var _login2 = _interopRequireDefault(_login);
	
	var _login3 = __webpack_require__(620);
	
	var _login4 = _interopRequireDefault(_login3);
	
	__webpack_require__(621);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var loginComponent = {
	  bindings: {},
	  template: _login2.default,
	  controller: _login4.default,
	  controllerAs: "vm"
	};
	
	exports.default = loginComponent;

/***/ }),
/* 619 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"page-header\"\r\n     filter-color=\"orange\">\r\n  <div class=\"page-header-image\"\r\n       style=\"background-image:url('/assets/img/background10.jpg'); background-position: right bottom; \"></div>\r\n  <div class=\"section section-signup\">\r\n    <div class=\"container\">\r\n      <div class=\"row\">\r\n        <div class=\"card card-signup\"\r\n             data-background-color=\"orange\">\r\n          <form class=\"form\">\r\n            <div class=\"header text-center\">\r\n              <div class=\"logo\">\r\n                <img src=\"/assets/img/Logo-white.png\"\r\n                     alt=\"Logo Parco Alpi Liguri\">\r\n              </div>\r\n              <h4 class=\"title title-up\">Area riservata</h4>\r\n            </div>\r\n            <div class=\"card-body\">\r\n              <div class=\"input-group form-group-no-border\">\r\n                <span class=\"input-group-addon\">\r\n                    <i class=\"now-ui-icons users_circle-08\"></i>\r\n                </span>\r\n                <input type=\"text\"\r\n                       ng-model=\"vm.user.username\"\r\n                       class=\"form-control\"\r\n                       placeholder=\"Nome utente\">\r\n              </div>\r\n              <div class=\"input-group form-group-no-border\">\r\n                <span class=\"input-group-addon\">\r\n                    <i class=\"now-ui-icons objects_key-25\"></i>\r\n                </span>\r\n                <input type=\"password\"\r\n                       ng-model=\"vm.user.password\"\r\n                       placeholder=\"Password\"\r\n                       class=\"form-control\"/>\r\n              </div>\r\n            </div>\r\n            <div class=\"footer text-center\">\r\n              <a href=\"\"\r\n                 class=\"btn btn-neutral btn-round btn-lg\"\r\n                 ng-click=\"vm.login()\">Accedi</a>\r\n            </div>\r\n          </form>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n"

/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(498);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LoginController = function LoginController(Account, growl, $http, store, $state) {
	  "ngInject";
	
	  (0, _classCallCheck3.default)(this, LoginController);
	  var vm = this;
	  vm.user = {
	    username: "",
	    password: ""
	  };
	  vm.login = login;
	
	  function login() {
	    Account.login(vm.user.username, vm.user.password).then(function (res) {
	      growl.info("Login effettuato con successo!");
	      store.set("token", "Bearer " + res.data.id_token);
	      $http.defaults.headers.common.Authorization = store.get("token");
	      $state.go("dashboard.list", { modelEnum: 'CULTURE' });
	    }, function (err) {
	      growl.error("Username o password non corretti. Riprovare");
	    });
	  }
	};
	LoginController.$inject = ["Account", "growl", "$http", "store", "$state"];
	
	exports.default = LoginController;

/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(622);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(349)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./login.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./login.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(348)();
	// imports
	
	
	// module
	exports.push([module.id, ".section-signup{background:transparent}.card-signup{margin-top:10%;padding:20px!important}.logo{width:90px;height:auto;margin:0 auto}", ""]);
	
	// exports


/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(368);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(370);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _confirmRegistration = __webpack_require__(624);
	
	var _confirmRegistration2 = _interopRequireDefault(_confirmRegistration);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var confirmRegistrationModule = _angular2.default.module('confirmRegistration', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('confirmRegistration', {
	    url: '/confirmRegistration/:key',
	    component: 'confirmRegistration',
	    params: {
	      key: null
	    }
	  });
	}]).component('confirmRegistration', _confirmRegistration2.default).name;
	
	exports.default = confirmRegistrationModule;

/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _confirmRegistration = __webpack_require__(625);
	
	var _confirmRegistration2 = _interopRequireDefault(_confirmRegistration);
	
	var _confirmRegistration3 = __webpack_require__(626);
	
	var _confirmRegistration4 = _interopRequireDefault(_confirmRegistration3);
	
	__webpack_require__(627);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var confirmRegistrationComponent = {
	  bindings: {},
	  template: _confirmRegistration2.default,
	  controller: _confirmRegistration4.default,
	  controllerAs: "vm"
	};
	
	exports.default = confirmRegistrationComponent;

/***/ }),
/* 625 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"page-header\"\r\n     filter-color=\"orange\">\r\n  <div class=\"page-header-image\"\r\n       style=\"background-image:url('/assets/img/background8.jpg')\"></div>\r\n  <div class=\"section section-signup\">\r\n    <div class=\"container\">\r\n      <div class=\"row\">\r\n        <div class=\"card card-signup\"\r\n             data-background-color=\"orange\">\r\n          <h5>{{vm.message}}</h5>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n"

/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(498);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ConfirmRegistrationController = function ConfirmRegistrationController($stateParams, Account) {
	  "ngInject";
	
	  (0, _classCallCheck3.default)(this, ConfirmRegistrationController);
	  var vm = this;
	  vm.name = 'confirmRegistration';
	  vm.message = '';
	  vm.init = init;
	  vm.init();
	
	  function init() {
	    Account.confirmRegistration($stateParams.key).then(function () {
	      vm.message = "Registrazione avvenuta con successo.";
	    }).catch(function () {
	      vm.message = "Questo link non è valido oppure è già stato utilizzato";
	    });
	  }
	};
	ConfirmRegistrationController.$inject = ["$stateParams", "Account"];
	
	exports.default = ConfirmRegistrationController;

/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(628);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(349)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./confirmRegistration.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./confirmRegistration.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(348)();
	// imports
	
	
	// module
	exports.push([module.id, ".section-signup{background:transparent}.card-signup{margin-top:10%;padding:50px}.logo{width:90px;height:auto;margin:0 auto}", ""]);
	
	// exports


/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(368);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _image = __webpack_require__(630);
	
	var _image2 = _interopRequireDefault(_image);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var imageModule = _angular2.default.module('image.service', []).service('Image', _image2.default).name;
	
	exports.default = imageModule;

/***/ }),
/* 630 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var Image = function Image($uibModal, $http, SERVER_URL) {
	  "ngInject";
	
	  return {
	    openDetail: openDetail,
	    deleteImage: deleteImage
	  };
	
	  function openDetail(_imageSource, _imageId, _callback) {
	    return $uibModal.open({
	      component: 'imageDetail',
	      // size: 'lg',
	      resolve: {
	        imageSource: function imageSource() {
	          return _imageSource;
	        },
	        imageId: function imageId() {
	          return _imageId;
	        },
	        callback: function callback() {
	          return _callback;
	        }
	      }
	    });
	  }
	
	  function deleteImage(id) {
	    console.log("Delete image from service!", id);
	    return $http.delete(SERVER_URL + "/images/" + id);
	  }
	};
	Image.$inject = ["$uibModal", "$http", "SERVER_URL"];
	exports.default = Image;

/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(368);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _account = __webpack_require__(632);
	
	var _account2 = _interopRequireDefault(_account);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var accountModule = _angular2.default.module('account.service', []).service('Account', _account2.default).name;
	
	exports.default = accountModule;

/***/ }),
/* 632 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var Account = function Account($http, SERVER_URL) {
	  "ngInject";
	
	  return {
	    login: login,
	    confirmRegistration: confirmRegistration
	  };
	
	  function login(username, password) {
	    return $http({
	      url: SERVER_URL + "/authenticate",
	      method: "POST",
	      data: {
	        username: username,
	        password: password,
	        rememberMe: false
	      }
	      //paramSerializer: '$httpParamSerializerJQLike',
	      // headers: {
	      //   'Authorization': 'Basic d2ViX2FwcDo=',
	      //   'Content-Type': 'application/x-www-form-urlencoded'
	      // },
	      // transformRequest: function(obj) {
	      //   var str = [];
	      //   for (var p in obj) {
	      //     str.push(encodeURIComponent(p) + '=' + encodeURIComponent(obj[p]));
	      //   }
	      //   return str.join('&');
	      // }
	    });
	  };
	
	  function confirmRegistration(key) {
	    return $http({
	      url: SERVER_URL + "/activate",
	      method: "GET",
	      params: { key: key }
	    });
	  }
	};
	Account.$inject = ["$http", "SERVER_URL"];
	exports.default = Account;

/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(368);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _report = __webpack_require__(634);
	
	var _report2 = _interopRequireDefault(_report);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var reportModule = _angular2.default.module('report.service', []).service('Report', _report2.default).name;
	
	exports.default = reportModule;

/***/ }),
/* 634 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var Report = function Report($http, SERVER_URL) {
	    "ngInject";
	
	    return {
	        getList: getList,
	        put: put,
	        postAdminComment: postAdminComment
	    };
	
	    function getList(page, offset, modelEnum) {
	        var params = {
	            page: page || 0,
	            size: offset || 25,
	            sort: "id,desc"
	        };
	        if (!!modelEnum) {
	            params.modelEnum = modelEnum;
	        }
	        return $http.get(SERVER_URL + "/reports/by-model-enum", {
	            params: params
	        });
	    }
	
	    function put(report) {
	        return $http.put(SERVER_URL + "/reports", report);
	    }
	
	    function postAdminComment(adminComment) {
	        return $http.post(SERVER_URL + "/admin-comments", adminComment);
	    }
	};
	Report.$inject = ["$http", "SERVER_URL"];
	exports.default = Report;

/***/ })
]);


// WEBPACK FOOTER //
// app.bundle.js